import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">

<path d="M6208 12223 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M6066 12209 c-149 -20 -315 -74 -480 -159 -119 -61 -158 -86 -586
-375 -371 -251 -648 -361 -1065 -424 -443 -68 -498 -79 -705 -147 -246 -81
-424 -185 -587 -346 -198 -194 -296 -380 -452 -859 -93 -288 -126 -372 -207
-539 -133 -271 -288 -486 -681 -945 -14 -16 -24 -30 -22 -30 2 0 -8 -12 -21
-26 -114 -118 -229 -284 -320 -464 -200 -392 -237 -824 -111 -1302 30 -114 70
-231 171 -503 185 -499 227 -686 265 -1190 48 -630 92 -911 180 -1155 33 -93
98 -232 116 -250 11 -11 -4 33 -23 68 -7 12 -12 27 -13 32 0 6 -6 20 -13 33
-7 13 -11 31 -9 40 3 12 5 10 6 -6 0 -13 5 -21 9 -18 4 3 19 -16 33 -42 13
-26 27 -49 30 -52 4 -3 9 -15 13 -26 4 -12 16 -30 28 -40 19 -18 19 -15 -5 31
-118 237 -194 498 -236 810 -19 147 -26 216 -56 615 -17 225 -27 301 -66 500
-31 160 -53 232 -44 145 l4 -50 -15 55 c-18 62 -110 316 -190 525 -29 77 -55
149 -57 160 -2 11 -11 36 -19 55 -9 19 -18 51 -22 70 -5 33 -4 31 19 -15 13
-27 24 -57 25 -65 1 -17 30 -59 30 -44 0 5 -9 34 -21 64 -38 100 -101 351
-119 475 -39 275 -15 603 64 870 13 44 30 105 36 135 24 104 156 325 222 370
20 14 51 43 68 65 45 56 304 343 331 365 13 11 127 157 138 178 6 11 19 23 30
27 10 3 18 13 17 23 0 9 5 16 12 15 6 -2 12 4 12 12 0 8 5 15 10 15 6 0 10 5
10 10 0 6 12 23 26 38 14 15 38 52 54 83 16 31 42 76 58 100 92 140 219 428
292 664 50 162 161 461 213 575 18 41 37 90 40 107 19 98 131 257 231 331 56
40 116 75 116 67 0 -8 60 24 95 51 17 12 86 51 155 86 118 60 141 70 215 98
40 16 294 66 375 75 36 4 72 8 80 10 8 1 42 6 75 9 187 23 434 76 576 125 138
46 280 114 415 197 49 29 92 54 96 54 7 0 39 19 158 94 54 35 150 98 207 139
29 20 56 37 59 37 3 0 23 14 44 30 21 17 42 30 48 30 5 0 15 7 22 15 10 13 77
51 207 120 61 33 238 105 258 105 8 0 23 4 33 9 26 15 110 39 176 50 113 20
74 27 -58 10z m-3982 -2731 c-20 -58 -63 -146 -75 -153 -13 -9 -12 -6 16 49
14 27 25 55 25 63 0 7 5 13 10 13 6 0 10 4 10 9 0 14 19 61 24 61 3 0 -2 -19
-10 -42z m-847 -4050 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m241 -1655 c6 -18 7 -35 3 -37 -4 -3 -8 0 -9 7 -1 7 -4 26 -8 42 -8 38 -1 31
14 -12z m20 -78 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z"/>
<path d="M5950 11529 c-163 -11 -469 -58 -620 -95 -294 -72 -534 -146 -726
-222 -112 -45 -326 -143 -321 -148 2 -2 41 12 88 32 440 186 779 287 1206 359
270 45 404 57 758 63 242 4 316 8 255 13 -113 9 -496 8 -640 -2z"/>
<path d="M6738 11513 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M6848 11503 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M7020 11484 c132 -18 425 -71 464 -84 16 -6 36 -10 45 -9 22 1 -25
15 -154 45 -114 27 -374 65 -429 63 -17 -1 16 -7 74 -15z"/>
<path d="M7558 11383 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7241 11286 c2 -2 18 -6 34 -10 22 -5 26 -4 15 4 -14 9 -59 15 -49 6z"/>
<path d="M6140 11270 c-441 -38 -636 -74 -1035 -191 -376 -110 -938 -367
-1218 -558 -37 -25 -87 -57 -111 -71 -23 -14 -58 -37 -77 -51 -19 -14 -77 -56
-129 -94 -127 -92 -225 -172 -340 -275 -127 -114 -362 -349 -435 -435 -33 -38
-69 -79 -80 -91 -11 -12 -31 -37 -45 -55 -14 -19 -52 -65 -86 -104 -33 -38
-67 -79 -76 -90 -9 -11 -40 -49 -69 -85 -29 -36 -55 -69 -59 -73 -4 -5 -3 7 3
26 6 20 16 33 21 30 5 -3 6 0 4 8 -3 8 -14 13 -24 12 -18 -1 -18 -1 1 13 12 9
21 11 23 4 5 -15 22 -12 22 4 0 7 9 25 21 40 11 14 18 26 15 26 -2 0 8 13 22
28 15 15 36 39 47 53 11 13 27 33 35 43 13 16 12 20 -4 31 -16 12 -22 9 -52
-37 -19 -27 -34 -57 -35 -67 0 -12 -2 -12 -9 4 -8 19 -9 19 -9 -1 -1 -12 -8
-24 -16 -28 -8 -3 -15 -15 -15 -26 0 -11 -6 -20 -12 -20 -21 0 -73 -71 -59
-79 8 -5 10 -22 5 -50 -8 -48 -18 -47 -16 1 1 23 -2 28 -8 18 -6 -8 -10 -23
-10 -33 0 -10 -4 -16 -8 -13 -4 2 -12 2 -17 -2 -18 -13 -46 -72 -40 -82 4 -6
1 -17 -5 -25 -7 -8 -9 -22 -6 -31 6 -15 4 -15 -10 -3 -14 11 -20 9 -45 -21
-25 -32 -28 -33 -22 -10 7 28 40 83 72 119 11 13 23 33 27 45 15 49 219 338
329 467 64 75 75 89 75 97 0 4 8 14 18 23 9 8 43 45 76 82 32 37 64 67 72 67
8 0 14 4 14 10 0 5 20 31 44 57 25 26 43 50 40 52 -11 12 -252 -248 -373 -404
-35 -44 -75 -95 -89 -114 -81 -101 -299 -437 -362 -556 -17 -33 -41 -76 -52
-95 -41 -70 -111 -214 -195 -400 -144 -321 -285 -825 -342 -1220 -156 -1078
68 -2206 630 -3165 45 -77 84 -142 88 -145 3 -3 12 -16 19 -30 19 -37 225
-324 307 -427 124 -158 339 -383 445 -469 45 -36 42 -32 -60 73 -47 48 -122
129 -166 178 -69 77 -105 119 -221 259 -107 130 -295 392 -320 446 -3 8 -10
17 -13 20 -4 3 -29 43 -56 90 -27 47 -51 87 -55 90 -7 6 -69 134 -69 144 0 3
-11 23 -24 44 -14 20 -50 96 -81 167 -32 72 -70 159 -86 195 -31 72 -58 145
-65 174 -6 33 -45 149 -61 184 -34 76 -133 490 -147 613 -4 29 -11 81 -16 114
-26 159 -35 253 -53 550 -4 53 -3 58 2 20 7 -48 7 -49 12 -15 l5 35 10 -35 c8
-27 12 27 17 245 7 337 34 604 82 845 9 41 18 91 21 110 10 56 80 315 118 435
69 221 161 450 195 486 l23 24 -17 -40 c-10 -22 -25 -58 -35 -80 -19 -44 -93
-263 -133 -395 -64 -209 -135 -535 -142 -650 -2 -36 -2 -54 1 -40 3 14 14 70
25 125 90 456 237 883 450 1300 314 618 770 1172 1314 1598 154 120 148 116
270 199 345 234 787 452 1192 587 522 175 1149 262 1675 233 117 -7 247 -17
288 -22 598 -80 1071 -230 1597 -505 339 -179 746 -469 1015 -724 38 -35 71
-62 74 -58 13 12 -294 287 -471 423 -32 24 -208 145 -285 195 -8 5 -39 25 -68
44 -30 19 -55 35 -57 35 -1 0 -47 25 -101 56 -143 81 -344 181 -494 246 -252
109 -694 237 -1030 297 -261 48 -702 71 -940 51z m-3796 -2232 c-34 -60 -69
-108 -72 -98 -3 7 5 25 17 41 12 16 19 35 15 41 -4 7 -3 8 5 4 6 -4 14 0 17 8
3 9 10 16 16 16 5 0 6 -6 2 -12z m-104 -167 c-10 -20 -30 -37 -30 -27 0 6 33
46 38 46 1 0 -2 -9 -8 -19z m-99 -45 c-12 -18 -21 -41 -21 -50 0 -9 -4 -16
-10 -16 -5 0 -16 -12 -24 -27 -9 -16 -15 -21 -16 -13 0 20 71 140 83 140 5 0
-1 -15 -12 -34z m60 -30 c-6 -14 -16 -26 -23 -26 -9 0 -8 3 2 10 8 5 11 10 7
10 -4 0 -3 9 3 21 16 28 23 18 11 -15z m-171 -176 c0 -5 -5 -10 -11 -10 -5 0
-7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-170 -410 c0 -5 -2 -10 -4 -10 -3
0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-86 -262 c-13 -44 -20 -55
-24 -42 -6 17 11 91 26 116 17 27 16 -17 -2 -74z m-57 -190 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-10 -40 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-10 -50 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m-40 -125 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m-37
-159 c0 -8 -5 -12 -10 -9 -6 4 -8 11 -5 16 9 14 15 11 15 -7z m-30 -149 c-6
-30 -8 -33 -9 -13 -1 25 8 62 14 56 2 -2 -1 -21 -5 -43z m-6 -70 c-4 -8 -8
-15 -10 -15 -2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z m-57 -567 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M7963 11254 c16 -8 70 -30 120 -49 51 -18 109 -41 131 -50 21 -9 40
-14 43 -11 2 2 -6 7 -19 11 -12 5 -54 22 -93 40 -69 32 -188 75 -203 75 -4 -1
6 -8 21 -16z"/>
<path d="M7400 11250 c14 -4 34 -8 45 -8 16 0 15 2 -5 8 -14 4 -34 8 -45 8
-16 0 -15 -2 5 -8z"/>
<path d="M5115 11200 c-708 -180 -1509 -626 -2050 -1143 -49 -47 -85 -86 -80
-87 6 0 23 11 39 25 29 25 52 25 42 0 -3 -8 0 -16 7 -19 9 -3 9 -5 0 -5 -7 -1
-18 -11 -24 -23 -8 -16 2 -11 32 17 23 22 49 45 56 52 28 25 11 22 -24 -4 -35
-27 -36 -27 -31 -6 3 12 2 23 -3 25 -11 4 34 58 47 58 5 0 16 8 25 18 8 9 34
33 58 52 24 19 49 40 55 46 7 6 23 14 36 18 19 6 21 5 10 -3 -10 -7 -11 -11
-3 -11 7 0 10 -7 7 -15 -4 -8 -11 -15 -16 -15 -6 0 -8 7 -4 15 3 8 1 15 -4 15
-5 0 -10 -10 -12 -22 -2 -15 -10 -23 -23 -23 -25 0 -45 -12 -45 -28 0 -8 3 -8
12 1 17 17 29 15 22 -3 -4 -8 -18 -15 -33 -15 -23 -1 -24 -2 -8 -11 13 -8 23
-7 35 2 73 57 122 105 114 114 -4 5 -2 5 5 1 7 -4 22 2 35 13 13 11 31 26 41
33 16 12 16 14 -5 27 -21 13 -22 13 -10 -2 17 -20 -3 -34 -24 -16 -13 10 -13
14 1 29 9 9 33 25 55 35 22 10 40 22 40 27 0 4 5 8 10 8 6 0 10 -7 10 -15 0
-17 -49 -44 -67 -38 -7 3 -13 0 -13 -6 0 -23 54 -10 101 25 27 20 49 40 49 45
0 5 6 9 14 9 8 0 18 5 22 12 4 6 3 8 -4 4 -5 -3 -13 0 -15 6 -4 10 -8 9 -16
-2 -6 -8 -11 -10 -11 -4 0 6 9 19 20 29 18 17 20 17 14 2 -3 -10 -1 -17 5 -17
10 0 15 13 12 32 0 3 33 29 74 57 66 45 96 56 64 24 -7 -7 -6 -12 5 -16 8 -3
17 1 20 9 3 8 12 14 21 14 8 0 15 5 15 10 0 6 -10 10 -22 10 -23 0 -23 0 2 20
14 10 36 25 50 32 29 15 148 84 170 99 8 5 35 19 60 31 25 11 47 24 50 28 7
10 107 61 220 113 185 85 227 103 428 176 89 33 220 76 290 96 70 20 145 43
167 50 70 24 -1 16 -120 -15z m-1555 -799 c0 -5 -9 -11 -20 -14 -22 -6 -28 8
-7 16 19 8 27 8 27 -2z m-172 -141 c3 -9 -1 -11 -11 -7 -9 3 -19 2 -22 -3 -4
-6 -14 -10 -23 -10 -13 0 -12 5 8 20 27 21 41 21 48 0z"/>
<path d="M7665 11180 c11 -5 27 -9 35 -9 9 0 8 4 -5 9 -11 5 -27 9 -35 9 -9 0
-8 -4 5 -9z"/>
<path d="M7790 11140 c8 -5 22 -10 30 -10 13 0 13 1 0 10 -8 5 -22 10 -30 10
-13 0 -13 -1 0 -10z"/>
<path d="M7841 11126 c3 -3 69 -28 214 -82 11 -4 17 -4 14 0 -8 8 -209 86
-223 86 -5 0 -7 -2 -5 -4z"/>
<path d="M9310 10975 c0 -8 3 -15 8 -16 4 0 17 -2 30 -3 30 -4 28 12 -4 24
-33 13 -34 13 -34 -5z"/>
<path d="M3058 10913 c-10 -2 -18 -8 -18 -13 0 -4 -8 -6 -19 -3 -23 6 -39 -16
-20 -28 9 -7 5 -7 -13 -3 -26 6 -28 4 -28 -23 0 -17 9 -38 20 -48 14 -13 20
-31 20 -62 0 -36 4 -46 20 -50 11 -3 20 -11 20 -18 0 -6 9 -20 20 -30 17 -15
20 -29 19 -69 -2 -41 1 -52 19 -64 12 -8 22 -21 22 -28 0 -8 7 -14 15 -14 9 0
12 -6 9 -15 -4 -11 -13 -13 -28 -9 -19 6 -19 5 -7 -10 23 -28 72 -1 107 60 7
12 22 19 41 19 19 0 30 5 29 14 -1 8 6 16 14 18 13 4 13 3 0 -6 -9 -7 -10 -11
-3 -11 16 0 26 17 13 25 -13 8 -13 45 0 45 6 0 10 11 10 25 0 27 -9 32 -28 13
-9 -9 -12 -9 -12 1 0 7 -13 25 -29 41 -21 22 -30 42 -35 82 -12 108 -18 129
-32 124 -7 -3 -27 6 -43 19 -28 24 -46 28 -83 18z m59 -25 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z"/>
<path d="M9182 10887 c3 -15 2 -27 -2 -27 -21 0 -18 -33 5 -56 26 -26 55 -32
55 -10 0 7 12 21 26 31 18 11 24 12 18 4 -6 -12 -5 -12 9 0 21 17 22 31 2 31
-8 0 -15 9 -15 20 0 16 -7 20 -34 20 -19 0 -42 3 -52 7 -14 5 -16 2 -12 -20z"/>
<path d="M6080 10846 c0 -4 85 -152 121 -211 10 -16 28 -47 39 -67 21 -38 34
-46 45 -28 3 6 -1 7 -9 4 -11 -4 -16 0 -16 11 0 9 5 13 11 9 6 -3 3 8 -6 25
-9 18 -20 29 -24 26 -5 -3 -7 4 -4 15 3 11 0 20 -6 20 -6 0 -11 7 -11 15 0 9
-6 12 -15 9 -11 -5 -13 -2 -8 12 4 12 3 15 -5 10 -7 -4 -12 -1 -12 8 0 9 -5
16 -11 16 -5 0 -8 4 -4 9 8 15 -17 63 -48 94 -28 26 -37 32 -37 23z m74 -92
c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m106 -175 c0 -6 -4 -7
-10 -4 -5 3 -10 11 -10 16 0 6 5 7 10 4 6 -3 10 -11 10 -16z"/>
<path d="M8875 10830 c3 -5 83 -62 178 -125 95 -64 187 -127 205 -142 17 -14
32 -23 32 -20 0 8 -172 141 -250 191 -104 68 -173 108 -165 96z"/>
<path d="M6413 10748 c-19 -23 -64 -120 -59 -125 3 -3 12 11 20 31 9 21 25 51
37 67 21 29 22 52 2 27z"/>
<path d="M5579 10711 c11 -7 11 -9 0 -13 -8 -3 -9 -9 -4 -18 5 -8 8 -30 6 -48
-3 -36 -36 -118 -51 -127 -6 -3 -10 -13 -10 -21 0 -8 -18 -52 -40 -96 -22 -45
-40 -88 -40 -95 0 -23 18 -14 24 14 4 14 45 102 92 195 84 169 97 201 70 179
-11 -9 -15 -6 -20 14 -4 15 -13 25 -24 25 -13 0 -14 -2 -3 -9z"/>
<path d="M5190 10673 c0 -27 23 -84 31 -76 11 11 -8 83 -21 83 -6 0 -10 -3
-10 -7z"/>
<path d="M8820 10656 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M5415 10645 c-5 -2 -47 -11 -92 -21 -50 -11 -83 -23 -83 -30 0 -7 -8
-15 -17 -17 -16 -4 -16 -5 -1 -6 9 0 63 10 120 23 62 15 104 21 106 15 3 -6 9
-5 18 2 26 22 -12 47 -51 34z"/>
<path d="M8860 10637 c0 -3 12 -12 26 -22 15 -9 23 -12 20 -6 -7 11 -46 35
-46 28z"/>
<path d="M7456 10588 c-9 -12 -16 -31 -16 -42 0 -17 3 -15 25 9 21 21 31 26
53 20 35 -8 54 -28 68 -67 9 -28 17 -33 65 -44 75 -18 79 -17 79 12 0 23 -2
25 -15 14 -13 -10 -23 -10 -54 5 -22 9 -44 15 -49 11 -5 -3 -7 5 -5 17 4 26
-2 35 -41 65 -38 29 -90 29 -110 0z"/>
<path d="M7301 10565 c-20 -75 23 -144 134 -214 96 -61 110 -92 61 -134 l-21
-18 25 6 c46 13 61 43 47 97 -5 19 -28 41 -78 73 -39 25 -75 43 -80 39 -6 -3
-19 2 -30 12 -19 17 -27 40 -9 29 5 -3 3 7 -5 22 -8 15 -15 47 -15 70 0 54
-16 64 -29 18z"/>
<path d="M8920 10598 c0 -3 26 -22 58 -44 31 -21 59 -41 62 -44 15 -15 90 -63
90 -57 0 4 -135 101 -182 132 -16 9 -28 15 -28 13z"/>
<path d="M3730 10521 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z"/>
<path d="M6286 10523 c-11 -11 -7 -225 4 -218 6 3 7 -1 4 -9 -5 -14 4 -16 60
-16 51 0 66 3 66 14 0 17 -31 29 -75 30 -25 1 -30 6 -36 35 -4 18 -5 62 -2 96
4 58 -4 84 -21 68z"/>
<path d="M6412 10495 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9367 10479 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M9141 10437 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24
17 -6 0 -8 -1 -6 -3z"/>
<path d="M2502 10393 c-34 -48 -93 -163 -119 -232 -13 -36 -31 -79 -38 -96
-17 -38 -28 -76 -60 -199 -14 -54 -29 -106 -34 -115 -5 -9 -12 -48 -16 -88 -7
-71 -7 -72 16 -66 15 4 20 3 15 -5 -4 -7 -1 -12 8 -12 9 0 16 -4 16 -10 0 -5
10 -14 22 -21 18 -10 20 -9 15 5 -4 10 -3 15 2 11 5 -3 24 10 42 29 18 19 36
33 41 30 4 -3 5 2 2 11 -4 10 -2 15 6 13 7 -2 21 13 32 32 11 19 27 42 36 50
14 14 15 13 3 -5 -8 -11 7 3 32 30 25 28 43 54 39 59 -3 5 0 6 5 3 12 -8 35
16 31 31 -2 5 2 11 7 12 19 3 35 22 28 33 -3 5 -2 7 4 4 5 -3 31 16 56 42 46
47 60 70 35 55 -7 -4 3 11 22 33 69 81 81 96 95 124 19 36 19 39 -4 39 -14 0
-18 6 -16 30 1 16 0 28 -4 27 -12 -3 -51 28 -51 40 0 7 -11 13 -25 13 -26 0
-74 43 -75 68 0 6 -12 12 -28 12 -16 0 -47 9 -70 20 -22 11 -43 20 -46 20 -2
0 -13 -12 -24 -27z"/>
<path d="M9565 10309 c50 -46 166 -158 258 -249 179 -176 209 -203 137 -127
-139 149 -337 340 -425 411 -41 33 -31 22 30 -35z"/>
<path d="M8141 10209 c-57 -94 -107 -186 -112 -206 -22 -99 42 -198 162 -253
86 -39 193 -17 247 51 l23 29 -66 -30 c-85 -38 -143 -39 -211 -5 -50 25 -71
33 -44 15 13 -9 13 -10 0 -10 -24 1 -52 27 -55 52 -2 13 -8 37 -15 53 -6 17
-12 53 -12 82 -1 53 22 103 79 179 45 61 120 193 114 202 -3 5 -53 -66 -110
-159z"/>
<path d="M4427 10363 c-2 -5 -1 -35 3 -68 30 -235 50 -390 55 -447 4 -38 11
-68 16 -68 20 0 119 55 119 66 0 18 -43 10 -77 -14 l-29 -21 -12 97 c-7 53
-19 160 -27 237 -19 190 -25 225 -35 225 -5 0 -11 -3 -13 -7z"/>
<path d="M5356 10330 c-8 -17 -10 -27 -4 -23 7 3 -2 -10 -18 -30 -16 -20 -37
-37 -46 -37 -21 0 -22 -3 -6 -70 10 -45 14 -51 32 -45 53 15 346 84 384 90 44
7 57 29 22 38 -14 3 -20 14 -20 32 0 26 -1 27 -42 20 -24 -4 -47 -10 -53 -14
-14 -11 -175 -35 -182 -28 -3 3 2 27 11 52 13 38 13 45 1 35 -10 -8 -19 -8
-34 -1 -27 15 -28 15 -45 -19z m327 -77 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5
14 0 19 -2 13 -5z"/>
<path d="M7217 10321 c-23 -113 117 -231 274 -231 101 0 170 53 184 141 l6 34
-21 -38 c-32 -58 -101 -97 -172 -97 -31 0 -78 7 -103 15 -25 9 -49 13 -54 10
-5 -3 -22 8 -38 23 -28 28 -53 98 -53 147 0 34 -16 32 -23 -4z"/>
<path d="M5722 10295 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M4557 10263 c3 -21 9 -51 14 -68 7 -24 7 -22 3 13 -3 23 -2 42 3 42
4 0 37 -29 72 -65 61 -62 81 -76 81 -56 0 14 -63 71 -77 71 -7 0 -13 6 -13 13
0 13 -70 87 -82 87 -4 0 -4 -17 -1 -37z"/>
<path d="M7478 10153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8624 10115 c-9 -14 -15 -28 -12 -30 2 -2 12 9 22 25 21 36 13 40
-10 5z"/>
<path d="M8230 10110 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M4903 10084 c4 -7 0 -15 -9 -18 -8 -3 -12 -2 -9 4 3 6 1 10 -6 10 -7
0 -9 -10 -6 -30 l6 -30 -39 26 c-37 24 -42 25 -72 14 -18 -8 -45 -21 -59 -31
-14 -10 -44 -25 -67 -34 -45 -18 -50 -33 -32 -100 8 -28 8 -27 7 10 l-2 40
100 52 c110 56 120 60 112 39 -3 -8 2 -20 11 -28 15 -12 16 -11 3 5 -7 9 -9
17 -3 17 14 0 35 -28 28 -38 -3 -6 0 -14 7 -20 8 -7 30 -1 75 21 58 28 86 56
43 42 -13 -4 -31 5 -57 27 -21 18 -35 28 -31 22z"/>
<path d="M3888 9869 c-2 -83 0 -153 5 -156 4 -2 7 66 7 151 0 86 -2 156 -4
156 -3 0 -6 -68 -8 -151z"/>
<path d="M3848 9983 c-10 -11 -18 -30 -18 -44 0 -19 2 -21 10 -9 8 12 10 10
10 -9 0 -16 -4 -22 -15 -17 -11 4 -15 -2 -16 -27 l-1 -32 -13 30 -13 30 -4
-50 -4 -50 -2 57 c-2 48 1 59 18 68 11 6 20 16 20 23 0 8 -3 8 -9 -2 -6 -9
-11 -10 -15 -2 -20 32 -26 0 -26 -134 0 -93 -4 -145 -10 -145 -7 0 -7 -6 0
-20 7 -14 7 -20 0 -20 -5 0 -9 -6 -7 -12 1 -8 -7 -12 -23 -11 l-25 3 25 -20
c15 -13 18 -18 7 -14 -14 5 -16 2 -11 -12 4 -11 -6 -5 -25 15 -17 19 -31 38
-31 42 0 4 -8 16 -17 25 -16 15 -16 17 -2 12 9 -4 23 -1 30 5 10 10 10 8 0 -6
-8 -9 -11 -20 -8 -23 3 -3 10 3 16 15 8 14 8 22 1 26 -6 4 -8 15 -5 25 3 11 0
20 -10 24 -8 3 -15 1 -15 -5 0 -6 -9 -8 -21 -4 -18 6 -19 5 -10 -13 18 -33 13
-37 -14 -12 -14 13 -24 29 -21 35 2 6 -5 11 -15 11 -17 0 -17 -2 -3 -26 15
-25 15 -25 -9 2 -14 15 -27 32 -29 39 -2 7 -10 9 -16 5 -9 -5 12 -36 65 -99
43 -51 86 -103 95 -117 19 -30 122 -141 112 -121 -5 9 -3 12 5 7 6 -4 9 -12 6
-17 -10 -15 46 -88 67 -89 11 0 88 70 88 80 0 4 -11 5 -25 2 -21 -4 -24 -1
-18 14 5 13 3 16 -10 11 -11 -4 -14 -2 -11 7 3 7 -3 19 -13 27 -16 13 -17 12
-4 -3 14 -19 3 -25 -17 -8 -9 7 -9 7 -2 -2 16 -19 12 -32 -5 -18 -13 11 -14
10 -9 -4 9 -22 -8 -20 -29 4 -22 26 -22 34 1 25 14 -5 15 -4 5 6 -18 18 -16
32 4 25 15 -6 15 -4 -2 14 -16 18 -16 20 -1 20 15 0 15 2 0 25 -20 30 -9 49
12 21 12 -17 14 -18 14 -3 0 9 3 17 8 17 4 0 64 -14 133 -31 l127 -32 66 48
c36 27 66 51 66 53 0 2 -15 2 -32 -2 -20 -3 -65 3 -113 15 -44 11 -114 28
-155 38 -69 16 -75 19 -78 44 -2 15 -8 25 -13 22 -5 -4 -5 5 1 20 13 35 13
108 0 100 -13 -8 -13 31 1 56 5 11 9 36 7 56 -3 34 -3 35 -20 16z m-11 -125
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m20 -70 c-3 -7 -5 -2 -5
12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-189 -195 l34 -48 -32 35 c-33 36 -59
76 -43 67 5 -3 23 -27 41 -54z m429 21 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11
1 17 -2 13 -5z m28 -14 c-11 -5 -27 -9 -35 -9 -9 0 -8 4 5 9 11 5 27 9 35 9 9
0 8 -4 -5 -9z m-42 -27 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z
m-283 -93 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11
-10z"/>
<path d="M3036 9975 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M2955 9950 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M2990 9929 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2953 9875 c5 -11 3 -22 -5 -27 -8 -5 -9 -8 -2 -8 23 0 33 24 16 40
-14 13 -15 12 -9 -5z"/>
<path d="M8964 9778 c-72 -87 -74 -89 -175 -207 -35 -41 -75 -87 -87 -103
l-24 -28 49 -44 c111 -100 181 -156 207 -166 39 -14 102 -12 136 5 33 17 70
61 70 84 0 11 -9 5 -25 -16 -45 -57 -141 -67 -200 -22 -13 11 -28 18 -33 15
-4 -2 -14 0 -22 6 -12 8 -12 9 2 4 12 -3 15 -1 11 10 -3 9 -13 13 -27 9 -13
-4 -16 -3 -9 2 9 6 -7 26 -52 66 -36 32 -65 62 -65 67 0 8 52 71 208 248 66
76 115 142 109 148 -2 3 -35 -32 -73 -78z"/>
<path d="M2885 9831 c3 -2 -3 -13 -12 -24 -10 -11 -18 -28 -18 -40 0 -13 -13
-28 -37 -41 -49 -28 -84 -74 -69 -89 8 -8 11 -6 11 7 0 10 4 14 12 10 6 -4 8
-3 5 3 -7 11 16 37 25 28 3 -3 22 14 44 38 54 60 61 69 68 94 6 18 3 22 -13
20 -11 -1 -18 -3 -16 -6z"/>
<path d="M9697 9799 c440 -482 749 -971 988 -1564 159 -395 255 -785 312
-1265 25 -208 25 -794 0 -1005 -74 -624 -223 -1150 -471 -1654 -25 -52 -44
-96 -42 -98 10 -10 131 246 200 425 9 23 23 59 30 80 141 364 233 743 297
1217 26 201 38 745 20 932 -71 722 -253 1307 -617 1990 -140 262 -385 600
-629 867 -44 48 -89 93 -100 99 -13 7 -9 -1 12 -24z"/>
<path d="M2825 9750 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M9032 9668 c-47 -61 -46 -82 1 -25 18 20 37 37 43 37 6 0 27 -16 47
-35 38 -37 47 -71 25 -93 -6 -6 -8 -15 -4 -19 12 -12 46 36 46 63 0 24 -87
124 -108 124 -5 0 -28 -24 -50 -52z"/>
<path d="M3690 9692 c0 -4 10 -13 23 -21 22 -14 22 -14 3 8 -20 22 -26 25 -26
13z"/>
<path d="M2723 9626 c5 -12 3 -16 -5 -14 -7 3 -26 -11 -42 -30 -17 -19 -41
-45 -54 -58 -13 -13 -20 -24 -17 -24 3 0 -6 -11 -20 -24 -22 -21 -25 -28 -15
-45 15 -29 21 -26 53 21 23 33 26 43 15 50 -9 7 -8 8 6 4 12 -4 24 0 32 11 70
93 72 97 56 113 -14 13 -15 12 -9 -4z"/>
<path d="M2349 9553 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8 -17
-17z"/>
<path d="M8906 9532 c-8 -15 -23 -36 -35 -46 -12 -11 -21 -26 -21 -35 0 -10
14 0 36 27 20 23 41 42 47 42 19 0 97 -83 97 -103 0 -10 -5 -27 -10 -38 -7
-13 -7 -19 -1 -19 10 0 41 51 41 68 0 4 -7 17 -16 28 -8 10 -12 13 -8 5 5 -9
3 -12 -4 -7 -7 4 -12 13 -12 20 0 15 -72 86 -88 86 -6 0 -18 -12 -26 -28z"/>
<path d="M9251 9484 c-25 -18 -47 -24 -83 -24 -64 0 -61 -24 3 -28 48 -3 88
19 109 59 13 23 13 23 -29 -7z"/>
<path d="M3055 9065 c-16 -5 -33 -14 -37 -20 -12 -16 -9 -80 4 -93 17 -17 28
-15 28 6 0 26 11 34 27 21 10 -9 13 -6 13 16 0 20 4 26 14 22 10 -4 13 -1 9 9
-3 7 -9 14 -13 14 -5 0 -10 8 -12 18 -3 15 -7 16 -33 7z"/>
<path d="M9426 9058 c-20 -28 -21 -92 -1 -111 8 -8 12 -17 10 -21 -3 -3 -2 -4
1 -1 4 2 16 -1 28 -7 20 -10 20 -10 4 8 -27 31 -27 84 0 85 10 0 12 3 5 6 -7
2 -13 15 -13 28 0 33 -16 39 -34 13z"/>
<path d="M2035 9038 l-16 -33 20 25 c20 24 26 40 16 40 -2 0 -12 -15 -20 -32z"/>
<path d="M3948 9008 c-3 -7 -2 -23 0 -35 4 -19 7 -21 18 -12 8 7 17 9 21 5 4
-3 -2 -13 -13 -21 -17 -13 -15 -14 32 -15 127 0 258 -51 318 -122 38 -44 71
-119 92 -209 17 -69 18 -189 22 -1874 2 -1285 0 -1832 -8 -1913 -19 -184 -55
-285 -128 -356 -36 -35 -39 -40 -26 -54 14 -13 20 -11 57 27 37 37 39 41 15
30 -16 -7 -28 -17 -28 -22 0 -6 -3 -7 -7 -4 -3 4 16 34 42 68 39 49 54 81 77
158 18 63 26 81 23 51 -5 -37 -27 -111 -59 -195 -5 -11 3 -2 17 21 14 22 36
85 49 140 l23 99 3 1835 c2 1346 0 1864 -8 1944 -21 190 -64 279 -175 364 -17
12 -23 21 -15 20 8 -2 16 1 17 7 1 5 10 12 20 16 12 5 6 8 -20 8 -26 1 -36 -3
-31 -11 5 -7 3 -8 -7 -2 -8 5 -25 9 -39 10 -148 10 -230 22 -245 37 -19 20
-32 22 -37 5z m222 -69 c-11 -8 -7 -9 17 -4 23 5 45 -1 81 -19 93 -47 147
-135 185 -301 21 -89 21 -113 24 -1485 2 -767 -1 -1514 -5 -1660 -6 -187 -9
183 -11 1255 -1 836 -6 1592 -10 1680 -9 162 -29 271 -61 335 -37 71 -178 180
-234 180 -19 0 -21 16 -3 23 22 9 32 7 17 -4z"/>
<path d="M4247 8899 c12 -12 24 -21 27 -18 2 2 -8 13 -22 23 l-27 19 22 -24z"/>
<path d="M6500 8981 c0 -45 10 -51 77 -51 75 0 151 -28 193 -70 72 -72 76
-171 12 -280 -35 -59 -156 -210 -261 -327 -25 -28 -73 -84 -106 -123 -33 -40
-109 -130 -170 -200 -60 -70 -132 -153 -160 -185 -91 -107 -309 -360 -315
-365 -6 -5 -170 -201 -259 -309 -30 -36 -83 -98 -118 -137 -35 -39 -63 -76
-63 -83 0 -6 -3 -11 -7 -11 -5 0 -17 -19 -28 -43 -23 -49 -51 -77 -76 -77 -26
0 -31 -14 -11 -36 10 -10 51 -59 92 -109 41 -49 77 -92 80 -95 3 -3 89 -99
190 -215 101 -115 186 -212 189 -215 5 -4 124 -139 163 -184 5 -6 8 -6 8 0 0
5 -17 27 -36 49 -155 173 -203 233 -196 241 4 5 3 6 -2 2 -8 -7 -131 125 -131
141 0 11 -32 41 -38 35 -3 -3 -8 3 -11 14 -4 11 -14 23 -22 26 -8 3 -13 10 -9
15 3 5 -4 13 -16 16 -13 4 -18 12 -15 21 3 8 2 12 -4 9 -5 -3 -14 5 -21 17 -7
12 -23 31 -36 41 -13 10 -20 23 -17 28 8 13 -26 50 -38 43 -4 -3 -7 0 -6 7 2
7 -3 13 -11 14 -19 0 -90 86 -84 102 9 22 19 15 75 -49 54 -64 298 -344 533
-613 141 -161 261 -301 425 -495 58 -68 137 -160 175 -204 134 -154 164 -196
137 -196 -10 0 -83 77 -152 160 -66 80 -75 91 -139 161 -28 31 -48 59 -43 64
4 5 1 5 -6 1 -14 -8 -12 -11 51 -81 9 -11 31 -37 47 -59 16 -21 51 -62 77 -91
85 -93 133 -157 133 -176 0 -8 -20 -45 -45 -82 -94 -146 -167 -322 -202 -490
-21 -100 -24 -380 -5 -477 33 -165 110 -360 193 -482 51 -75 61 -75 13 -1 -53
83 -120 227 -142 308 -25 88 -25 87 -23 105 1 8 19 -32 40 -90 133 -367 361
-610 714 -760 188 -79 337 -109 551 -111 l141 -2 -89 -9 c-92 -10 -246 -1
-356 21 -97 20 -250 64 -250 73 0 4 -7 8 -16 8 -56 0 83 -55 226 -89 247 -59
538 -46 795 35 73 23 259 110 323 151 138 89 297 235 388 358 25 33 54 71 65
85 10 13 19 28 19 33 0 4 16 32 35 62 86 134 173 415 194 624 14 137 14 224 0
215 -6 -3 -9 -20 -6 -38 5 -38 -8 -164 -28 -271 -40 -203 -153 -472 -264 -625
-28 -38 -51 -73 -51 -77 -1 -14 -59 -86 -118 -147 -38 -39 -79 -68 -122 -88
-36 -16 -72 -36 -80 -43 -8 -7 -26 -16 -40 -20 -13 -4 -37 -17 -51 -28 -15
-10 -33 -17 -41 -14 -8 4 -7 6 6 6 12 1 16 6 12 17 -3 9 -6 18 -6 22 0 3 -6
-2 -13 -13 -13 -16 -15 -14 -24 24 -8 30 -8 41 0 41 6 0 1 10 -11 23 -21 20
-24 21 -36 5 -8 -11 -17 -14 -27 -7 -11 7 -11 9 4 9 9 0 17 5 17 10 0 6 -19 0
-42 -12 -24 -12 -49 -21 -56 -20 -7 2 -25 -4 -40 -12 -46 -26 -162 -66 -267
-92 -204 -50 -419 -41 -627 26 -57 18 -96 26 -103 20 -6 -5 -17 -5 -25 0 -8 6
-29 10 -47 10 -21 0 -37 7 -47 22 -9 12 -29 23 -47 25 -18 2 -29 0 -25 -4 4
-5 11 -8 14 -8 13 0 32 -16 32 -26 0 -6 -7 -6 -19 0 -19 11 -96 12 -85 2 3 -3
22 -6 42 -6 35 0 37 -2 34 -28 -3 -25 0 -28 20 -23 13 3 17 3 10 0 -20 -9 77
-63 183 -100 50 -18 82 -33 73 -33 -56 -2 -281 104 -388 183 -102 75 -250 231
-250 264 0 6 -4 12 -8 14 -4 2 -19 21 -32 43 -21 35 -21 38 -4 22 25 -21 54
-22 54 -2 0 8 4 15 9 15 17 0 20 43 4 73 -12 24 -17 27 -25 16 -8 -11 -9 -10
-4 3 3 10 -10 50 -28 90 -18 40 -37 84 -43 98 -32 80 -48 109 -54 99 -3 -6 -9
-2 -12 11 -4 16 -2 20 9 16 11 -4 13 0 9 17 -30 128 -38 188 -39 287 -1 103
-3 115 -18 114 -10 -1 -18 3 -19 10 -3 41 -18 -63 -20 -135 -2 -91 -19 -128
-19 -41 0 124 40 348 82 455 13 34 2 49 -12 16 -9 -20 -9 -19 -4 11 7 38 51
137 65 146 5 3 4 -7 -1 -21 -15 -41 -11 -53 7 -20 9 17 19 32 23 35 3 3 32 46
64 97 36 58 55 97 50 105 -4 7 -57 72 -118 143 -61 72 -122 144 -136 161 -54
68 -161 195 -303 358 -206 237 -221 255 -336 391 -56 66 -113 132 -126 148
-39 43 -29 49 15 9 40 -35 70 -49 70 -31 0 5 5 9 10 9 16 0 70 58 70 75 0 7 5
17 11 21 6 3 9 19 7 35 -3 15 -1 26 3 23 11 -6 40 26 34 37 -4 5 -13 9 -21 9
-8 0 -14 5 -14 11 0 6 9 8 23 4 12 -3 18 -3 12 2 -21 17 -35 54 -30 76 4 16 0
28 -11 38 -11 9 -15 9 -10 2 5 -9 1 -13 -11 -13 -27 0 -57 24 -51 41 7 19 -9
49 -26 49 -21 0 -37 25 -39 62 -3 35 -13 58 -27 58 -4 0 -6 -9 -3 -20 4 -15 0
-20 -13 -20 -11 0 -34 -9 -52 -20 -18 -11 -37 -20 -42 -20 -5 0 -21 -11 -36
-25 -15 -14 -32 -25 -38 -25 -37 0 -63 -101 -33 -132 31 -33 114 -135 121
-148 7 -14 -35 29 -129 132 -131 142 -127 137 -113 153 7 8 18 20 23 27 6 8
35 43 66 78 30 36 64 76 75 89 31 38 147 174 167 193 9 10 17 24 17 31 0 7 19
33 43 57 23 25 55 63 72 85 16 22 42 51 58 65 43 38 102 100 137 145 17 22 44
52 58 66 28 27 68 74 168 194 32 39 95 113 139 165 45 52 91 106 102 120 12
14 57 68 100 120 44 52 85 105 92 118 7 12 16 20 22 17 5 -4 9 -1 9 5 0 6 7
18 16 27 8 9 13 22 10 30 -3 8 -1 11 4 8 6 -3 10 0 10 8 0 8 30 50 66 93 73
88 98 130 115 198 12 49 28 61 30 24 1 -13 5 -5 9 17 30 147 -92 265 -274 265
-30 0 -48 6 -61 20 -29 32 -45 25 -45 -19z m40 -26 c-7 -9 -15 -13 -17 -11 -7
7 7 26 19 26 6 0 6 -6 -2 -15z m157 -21 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m91 -22 c23 -15 52 -61 52 -83 0 -7 -11 -1 -23 13 -13 14
-42 38 -65 53 -23 15 -39 32 -36 37 7 10 39 1 72 -20z m-1427 -2379 c13 -16
12 -17 -3 -4 -10 7 -18 15 -18 17 0 8 8 3 21 -13z m1028 -2523 c0 -9 -4 -8 -9
5 -5 11 -9 27 -9 35 0 9 4 8 9 -5 5 -11 9 -27 9 -35z m1903 -792 c-6 -6 -15
-8 -19 -4 -4 4 -1 11 7 16 8 5 17 7 19 4 3 -2 -1 -10 -7 -16z"/>
<path d="M5588 8982 c-6 -21 -9 -22 -28 -12 -29 15 -157 4 -233 -21 -103 -34
-133 -61 -182 -163 -25 -53 -48 -118 -54 -156 -12 -73 -18 -1407 -13 -2875 3
-886 4 -923 23 -1003 19 -76 59 -188 44 -122 -42 188 -40 97 -40 2025 0 1918
-1 1879 45 2028 46 150 201 247 392 247 52 0 62 10 56 52 l-3 23 -7 -23z"/>
<path d="M7830 8985 c0 -12 -13 -15 -57 -15 -128 -1 -266 -50 -363 -129 -138
-112 -589 -584 -756 -791 -15 -19 -51 -60 -78 -90 -28 -31 -99 -112 -157 -180
-59 -69 -115 -134 -125 -145 -60 -64 -206 -231 -319 -364 -71 -85 -138 -163
-148 -175 -11 -11 -35 -41 -55 -66 -21 -24 -56 -65 -79 -91 -49 -52 -53 -69
-20 -69 15 0 32 12 47 32 13 18 34 44 46 58 12 14 40 46 61 71 49 59 385 448
409 474 11 11 59 67 109 125 126 147 298 343 368 419 33 35 68 78 78 95 10 17
19 28 19 23 0 -8 45 38 155 159 367 407 446 479 590 542 86 37 131 49 218 58
l67 7 0 33 c0 19 -2 34 -5 34 -3 0 -5 -7 -5 -15z"/>
<path d="M3280 8916 c-40 -26 -80 -38 -80 -25 0 12 -71 11 -90 -1 -12 -7 -12
-10 -1 -10 7 0 11 -6 8 -14 -4 -11 -1 -13 10 -9 11 4 14 2 9 -5 -10 -16 67
-16 97 -1 29 15 66 49 78 72 12 21 12 21 -31 -7z m-93 -32 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M3160 8920 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M9660 8902 c-34 -17 -58 -22 -98 -20 -37 2 -51 0 -48 -9 3 -6 0 -14
-7 -16 -23 -8 63 -19 99 -13 32 7 116 69 104 78 -3 2 -25 -7 -50 -20z"/>
<path d="M4445 8900 c-10 -11 -15 -20 -10 -20 4 0 2 -6 -4 -14 -14 -17 5 -56
26 -56 15 0 17 -12 3 -26 -11 -11 -2 -56 10 -49 5 3 7 -3 6 -12 -2 -10 3 -31
10 -48 20 -49 34 -199 34 -367 0 -94 4 -159 10 -163 6 -4 10 8 11 27 1 31 1
32 9 8 5 -15 8 -18 9 -8 1 13 9 15 41 12 24 -3 40 -1 40 6 0 5 18 10 40 10 22
0 40 4 40 9 0 5 12 11 28 13 23 3 27 8 30 41 2 20 7 37 13 37 5 0 9 7 9 15 0
8 4 15 10 15 5 0 12 11 16 25 3 14 10 22 15 19 12 -7 11 0 -7 46 -9 22 -20 40
-25 40 -5 0 -9 18 -9 40 0 22 -4 40 -10 40 -5 0 -10 7 -10 15 0 8 -13 28 -30
43 -16 16 -30 34 -30 40 0 6 -9 16 -20 22 -11 6 -20 17 -20 24 0 8 -9 16 -20
19 -13 3 -20 14 -20 30 0 14 -7 28 -16 31 -8 3 -13 9 -11 14 3 4 -1 22 -8 40
-8 18 -15 36 -15 40 -4 19 -23 32 -35 22 -6 -5 -15 -6 -19 -2 -8 7 -13 8 -41
11 -8 0 -14 6 -12 12 4 21 -19 20 -38 -1z"/>
<path d="M1823 8652 c-27 -47 -129 -289 -137 -322 -6 -26 17 18 52 100 11 25
40 92 66 149 47 108 55 139 19 73z"/>
<path d="M6840 8600 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M2842 8335 c-23 -41 -42 -79 -42 -84 0 -5 -6 -16 -13 -23 -14 -15
-39 -69 -34 -74 1 -2 16 22 33 54 16 31 47 88 68 125 21 37 37 70 35 72 -3 2
-23 -30 -47 -70z"/>
<path d="M9890 8385 c0 -2 9 -19 20 -37 23 -39 27 -30 5 12 -14 27 -25 38 -25
25z"/>
<path d="M1653 8255 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M9960 8257 c0 -5 7 -21 15 -35 88 -162 218 -515 266 -721 24 -105 23
-128 -1 -41 -22 79 -26 63 -5 -23 8 -34 23 -100 34 -147 101 -435 107 -1057
15 -1550 -47 -257 -155 -620 -248 -842 -9 -21 -16 -45 -16 -55 1 -10 9 4 20
30 10 27 22 54 27 60 10 12 56 133 69 177 3 14 10 27 13 30 7 5 56 150 85 250
29 98 106 448 106 478 0 17 4 32 10 34 5 2 10 26 11 53 1 28 5 55 9 60 36 49
46 614 15 850 -9 72 -19 147 -21 167 -2 21 -15 95 -30 165 -14 71 -28 139 -31
153 -25 145 -130 473 -198 625 -84 186 -145 304 -145 282z m325 -932 l6 -40
-16 34 c-16 36 -22 88 -6 61 5 -8 12 -33 16 -55z m22 -127 c-3 -7 -5 -2 -5 12
0 14 2 19 5 13 2 -7 2 -19 0 -25z"/>
<path d="M2688 8208 c-16 -25 -29 -58 -24 -58 2 0 13 18 25 40 22 43 22 54 -1
18z"/>
<path d="M2718 8098 c-12 -24 -30 -59 -39 -78 -31 -61 -106 -251 -143 -360
-45 -135 -123 -439 -131 -510 -3 -34 4 -12 19 55 58 266 178 629 266 805 35
69 60 130 55 130 -3 0 -15 -19 -27 -42z"/>
<path d="M4552 8115 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9995 8118 c4 -13 11 -27 16 -33 5 -5 4 5 -2 23 -12 36 -24 44 -14
10z"/>
<path d="M2619 8073 c-34 -75 -65 -143 -88 -198 -13 -27 -47 -122 -76 -210
-195 -576 -252 -1200 -164 -1800 38 -267 93 -501 166 -715 15 -43 23 -66 88
-238 15 -40 29 -71 31 -69 2 2 -6 27 -17 56 -11 30 -18 59 -15 65 3 7 5 7 5
-1 1 -7 14 -41 30 -75 16 -35 49 -108 74 -163 56 -124 77 -164 77 -148 0 7
-21 59 -46 115 -25 57 -59 135 -75 173 -17 39 -36 84 -43 100 -18 39 -111 319
-138 415 -71 255 -134 673 -142 945 -7 226 23 602 60 770 9 39 18 84 20 100 9
71 75 338 93 380 14 31 71 219 71 232 0 6 5 24 12 40 6 15 10 34 9 42 -1 7 2
10 7 7 6 -3 8 2 5 14 -3 11 0 20 6 20 6 0 11 5 11 11 0 6 16 47 35 92 37 86
41 122 4 40z m-190 -2755 c5 -13 11 -39 15 -58 4 -24 0 -18 -14 20 -22 63 -22
60 -15 60 3 0 9 -10 14 -22z m50 -168 c0 -9 -4 -8 -9 5 -5 11 -9 27 -9 35 0 9
4 8 9 -5 5 -11 9 -27 9 -35z m21 -65 c0 -5 -5 -3 -10 5 -5 8 -10 20 -10 25 0
6 5 3 10 -5 5 -8 10 -19 10 -25z"/>
<path d="M10101 7875 c1 -19 18 -51 18 -35 0 8 -4 22 -9 30 -5 8 -9 11 -9 5z"/>
<path d="M10131 7795 c1 -19 18 -51 18 -35 0 8 -4 22 -9 30 -5 8 -9 11 -9 5z"/>
<path d="M7383 7758 c-61 -31 -46 -33 18 -3 30 14 47 25 39 25 -8 0 -34 -10
-57 -22z"/>
<path d="M7760 7734 c-41 -7 -143 -34 -175 -46 -27 -10 -123 -75 -151 -103
-28 -27 -98 -141 -121 -197 -23 -56 -27 -79 -29 -203 l-3 -140 14 105 c28 223
105 355 264 451 89 53 184 72 336 67 138 -6 210 -26 315 -88 182 -109 304
-306 339 -549 l6 -46 55 0 55 0 1 360 c0 271 -1 320 -6 200 -4 -88 -8 -245 -9
-349 l-1 -188 -22 14 c-15 10 -27 33 -35 69 -7 30 -17 74 -23 99 -6 25 -34 91
-61 148 -117 242 -342 384 -629 396 -52 3 -106 3 -120 0z m460 -107 c95 -46
216 -169 263 -267 56 -115 57 -149 2 -54 -84 147 -202 261 -337 330 -27 13
-48 27 -48 30 0 11 54 -6 120 -39z m360 -627 c0 -5 -5 -10 -11 -10 -5 0 -7 5
-4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M10164 7695 c10 -42 34 -121 44 -145 10 -24 11 -24 11 -3 1 12 -3 24
-8 27 -5 3 -12 22 -15 41 -4 19 -14 49 -22 67 -8 18 -13 24 -10 13z"/>
<path d="M7199 7644 c-92 -70 -157 -138 -218 -230 -153 -228 -200 -536 -124
-819 17 -61 87 -225 97 -225 3 0 -5 25 -19 55 -25 58 -75 235 -74 263 0 10 10
-17 23 -58 26 -86 49 -141 78 -188 31 -50 32 -32 2 34 -15 32 -38 100 -53 149
-23 81 -26 106 -25 250 0 134 4 174 23 245 13 47 26 96 29 110 3 14 9 28 14
31 5 3 11 26 12 50 4 56 72 174 141 243 28 28 76 59 82 53 3 -3 17 5 31 18 15
12 41 34 57 49 59 50 0 27 -76 -30z"/>
<path d="M880 7219 c-21 -76 -6 -353 25 -472 14 -55 30 -108 36 -118 5 -11 7
-24 4 -29 -3 -5 -1 -11 5 -15 5 -3 14 -24 20 -45 10 -35 30 -56 30 -30 0 5 7
7 15 4 10 -4 15 0 15 12 0 14 3 15 8 6 5 -7 23 -17 42 -22 28 -8 35 -7 47 10
18 26 38 25 50 -2 8 -18 17 -21 65 -21 54 1 56 1 62 -29 3 -17 6 -63 7 -102 0
-39 6 -138 12 -221 11 -140 12 -121 12 300 0 312 4 474 13 529 8 54 9 83 2 90
-15 15 -12 36 5 36 9 0 15 9 15 24 0 13 3 33 6 43 5 15 4 15 -5 3 -6 -8 -11
-25 -11 -37 0 -13 -5 -23 -12 -23 -6 0 -9 3 -5 6 3 4 0 19 -9 35 -12 23 -21
29 -48 29 -19 0 -47 7 -62 15 -16 8 -45 15 -64 15 -19 1 -46 7 -60 15 -14 8
-40 14 -57 15 -18 0 -33 5 -33 10 0 14 -87 13 -96 -1 -4 -8 -9 -7 -14 2 -6 8
-12 -3 -20 -32z"/>
<path d="M1672 7135 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1662 7080 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M2382 7023 c-7 -40 -12 -84 -11 -100 1 -15 7 13 15 62 8 50 13 94 11
100 -2 5 -9 -23 -15 -62z"/>
<path d="M11102 7025 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1652 6980 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M11118 6840 c3 -58 5 -227 5 -377 -3 -439 -55 -848 -159 -1248 -36
-138 -154 -502 -174 -537 -6 -10 -10 -24 -10 -32 0 -8 -15 -47 -34 -88 -59
-129 -97 -247 -51 -157 73 140 222 562 285 804 67 260 127 630 151 930 13 163
6 686 -11 765 -6 32 -7 15 -2 -60z"/>
<path d="M2356 6822 c-4 -41 -5 -76 -3 -79 7 -6 20 122 15 139 -3 7 -8 -20
-12 -60z"/>
<path d="M11783 6760 c-18 -28 -28 -120 -13 -120 8 0 9 10 5 31 -5 22 -4 29 4
25 7 -5 9 -1 5 9 -4 9 -1 27 6 41 16 29 9 41 -7 14z"/>
<path d="M4631 6644 c-1 -22 -25 -39 -42 -28 -5 3 -9 -4 -9 -15 0 -26 -17 -36
-23 -14 -4 17 -5 17 -6 0 0 -10 -5 -15 -11 -12 -5 3 -10 -1 -10 -10 0 -9 5
-13 10 -10 6 3 10 2 10 -4 0 -5 -5 -11 -10 -13 -7 -2 -11 -99 -11 -291 0 -242
3 -291 16 -310 8 -12 15 -16 15 -8 0 11 5 10 23 -2 12 -8 21 -20 20 -26 -5
-21 133 -36 141 -15 3 8 -1 14 -9 14 -8 0 -15 9 -15 20 0 19 7 20 119 20 86 0
121 -3 124 -12 3 -7 6 26 6 75 1 51 5 87 11 87 13 0 13 207 1 212 -5 2 -12 25
-15 52 -5 44 -25 75 -49 76 -5 0 -15 7 -24 15 -14 14 -14 18 1 34 21 23 13 29
-46 37 -26 4 -48 10 -48 15 0 5 -4 9 -9 9 -5 0 -23 12 -39 28 -49 45 -60 52
-82 52 -12 0 -24 9 -30 23 -9 22 -9 22 -9 1z"/>
<path d="M11754 6622 c4 -7 3 -12 -1 -12 -5 0 -19 -35 -32 -77 -12 -43 -34
-109 -47 -148 -14 -38 -28 -81 -30 -93 -6 -29 -82 -259 -95 -287 -19 -41 -59
-155 -63 -181 -3 -15 -17 -64 -30 -108 -14 -45 -27 -92 -28 -106 -2 -14 -7
-28 -12 -31 -4 -4 -3 -9 2 -13 7 -4 16 11 23 36 6 24 16 54 22 68 28 66 111
312 122 363 3 17 10 25 17 21 7 -4 8 -3 4 4 -4 6 -2 19 4 29 16 28 50 135 50
157 0 11 6 27 14 35 25 28 68 207 59 242 -3 11 0 19 6 19 6 0 11 9 11 21 0 11
5 29 10 39 7 13 7 21 -2 26 -7 4 -8 3 -4 -4z"/>
<path d="M10442 6470 c-10 -562 -136 -1141 -364 -1665 -78 -180 -98 -238 -43
-125 187 381 309 785 374 1235 25 171 44 457 39 585 -4 92 -4 91 -6 -30z"/>
<path d="M6990 6394 c0 -3 11 -22 25 -42 30 -44 33 -33 4 14 -19 32 -29 41
-29 28z"/>
<path d="M6960 6356 c0 -10 59 -96 66 -96 3 0 -9 21 -27 48 -39 57 -39 57 -39
48z"/>
<path d="M11286 6298 c-3 -35 -8 -115 -11 -178 -18 -341 -109 -836 -222 -1200
-36 -119 -131 -386 -157 -443 -8 -18 -38 -86 -66 -151 -92 -209 -184 -381
-359 -665 -28 -46 -50 -85 -48 -87 4 -5 86 120 152 233 68 115 69 116 87 143
33 50 197 388 243 500 99 240 190 527 258 810 64 265 115 651 131 993 5 117 1
144 -8 45z"/>
<path d="M7070 6274 c0 -17 142 -169 225 -240 75 -64 166 -134 290 -224 503
-365 678 -511 815 -681 43 -54 96 -128 119 -166 80 -136 153 -358 150 -460 -1
-36 -2 -35 -13 17 -20 89 -67 242 -86 280 -10 19 -32 63 -49 98 -17 35 -40 73
-51 85 -11 11 -20 24 -20 28 0 7 -51 72 -89 114 -10 11 -25 34 -34 50 -8 17
-34 48 -58 70 -23 22 -39 34 -35 28 4 -7 3 -13 -2 -13 -12 0 -43 35 -37 42 3
2 -7 15 -22 29 -21 19 -24 20 -14 4 8 -11 1 -6 -15 10 -16 17 -38 35 -49 42
-11 6 -19 16 -18 22 2 6 -4 8 -14 4 -10 -4 -14 -2 -9 5 3 6 1 14 -5 18 -8 4
-9 3 -5 -4 10 -17 -9 -15 -23 2 -9 11 -9 15 1 18 8 3 6 7 -6 11 -10 4 -15 3
-11 -3 11 -18 -12 -10 -30 10 -14 15 -15 20 -4 20 16 1 -18 31 -103 91 -32 22
-58 37 -58 32 0 -4 16 -19 35 -32 20 -13 33 -26 31 -28 -7 -8 -86 59 -80 68 5
9 -54 56 -196 156 -52 36 -105 75 -117 86 -12 10 -26 16 -32 13 -5 -4 -13 -1
-17 5 -5 8 -3 9 6 4 8 -5 11 -4 6 3 -4 6 -14 8 -23 5 -10 -4 -14 -2 -10 4 6
10 -12 31 -42 48 -9 5 -12 4 -7 -3 11 -18 -3 -14 -26 8 -12 11 -26 20 -32 20
-10 0 64 -69 75 -70 3 0 17 -10 30 -21 26 -23 32 -28 184 -139 651 -478 838
-664 967 -965 70 -163 98 -358 78 -543 -35 -327 -185 -595 -436 -777 -79 -58
-160 -97 -286 -140 -112 -38 -117 -46 -10 -16 134 38 346 145 393 200 18 20
50 56 73 81 79 85 188 265 232 384 10 27 20 44 22 38 2 -6 -1 -20 -7 -31 -13
-24 -15 -49 -2 -35 5 5 20 50 34 99 83 293 52 613 -84 875 -76 145 -126 214
-258 354 -75 79 -76 79 -26 45 28 -19 53 -38 57 -44 4 -5 13 -10 20 -11 34 -3
38 -5 38 -25 0 -11 4 -18 10 -14 13 8 61 -5 54 -16 -3 -5 0 -9 5 -9 6 0 11 9
11 20 0 11 -5 20 -11 20 -6 0 -17 7 -25 15 -14 13 -14 15 1 15 9 0 14 3 12 8
-3 4 -8 64 -11 135 -5 118 -7 129 -30 152 -14 14 -32 25 -41 25 -12 0 -15 6
-10 21 5 16 4 19 -5 14 -8 -5 -11 -4 -7 3 9 14 -3 43 -14 36 -5 -3 -9 0 -9 6
0 6 -4 8 -10 5 -5 -3 -10 3 -10 13 0 11 -7 22 -15 26 -9 3 -15 18 -15 40 0 26
-5 36 -21 41 -13 5 -19 13 -16 24 3 12 -2 17 -17 17 -11 -1 -21 4 -21 10 0 15
-31 44 -39 37 -3 -4 -6 1 -6 10 0 9 -6 17 -13 17 -14 0 -55 49 -59 72 -2 7
-18 22 -36 34 -19 11 -32 23 -30 26 4 6 -28 38 -39 38 -4 0 -20 6 -35 14 -25
13 -28 13 -34 -6 -9 -29 -22 -5 -20 37 1 26 -2 31 -17 27 -13 -3 -16 0 -11 12
8 20 -5 20 -34 0 -21 -14 -22 -14 -22 5 0 20 -14 26 -50 23 -8 -1 -42 -2 -74
-3 -37 0 -74 -7 -99 -20 -23 -10 -46 -19 -51 -19 -15 0 -96 -126 -96 -149 0
-14 42 -52 104 -94 22 -16 41 -31 41 -35 -1 -8 34 -38 91 -78 101 -72 134 -98
134 -106 0 -5 -6 -4 -12 2 -7 6 -53 39 -103 75 -231 166 -297 216 -390 296
-55 47 -130 119 -168 159 -37 41 -67 70 -67 64z m720 -125 c0 -5 -7 -9 -15 -9
-15 0 -20 12 -9 23 8 8 24 -1 24 -14z m-385 -239 c8 -13 -5 -13 -25 0 -13 8
-13 10 2 10 9 0 20 -4 23 -10z m145 -110 l35 -31 -42 27 c-24 15 -43 28 -43
30 0 11 20 1 50 -26z m174 -127 c37 -29 64 -53 60 -52 -5 0 -29 16 -54 34 -25
19 -64 47 -87 62 -23 15 -42 31 -43 36 0 10 39 -16 124 -80z m168 -49 c35 -25
82 -57 104 -72 23 -16 54 -40 70 -54 16 -15 59 -52 97 -83 37 -32 67 -62 67
-67 0 -5 -17 5 -38 24 -110 95 -188 158 -254 206 -95 68 -125 92 -116 92 4 0
36 -20 70 -46z m38 -104 c19 -17 30 -30 25 -30 -6 1 -26 14 -45 30 -19 17 -30
30 -25 30 6 -1 26 -14 45 -30z m345 -290 c10 -11 14 -20 8 -20 -5 0 -18 9 -28
20 -10 11 -14 20 -8 20 5 0 18 -9 28 -20z m392 -1037 c-3 -10 -5 -4 -5 12 0
17 2 24 5 18 2 -7 2 -21 0 -30z m-17 -109 c-7 -36 -14 -63 -16 -61 -3 2 1 37
8 76 7 40 14 68 16 61 2 -6 -1 -40 -8 -76z"/>
<path d="M5711 6254 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1560 6172 c0 -18 5 -32 10 -32 6 0 8 11 4 28 -10 39 -14 40 -14 4z"/>
<path d="M7082 6180 c7 -11 17 -20 22 -20 5 0 1 9 -9 20 -10 11 -20 20 -22 20
-2 0 2 -9 9 -20z"/>
<path d="M7194 6067 c83 -79 113 -98 100 -62 -4 8 -10 13 -14 10 -9 -5 -51 27
-104 80 -17 17 -40 37 -51 44 -11 7 20 -25 69 -72z"/>
<path d="M1347 5935 c3 -33 7 -62 9 -64 8 -8 2 74 -7 99 -5 16 -6 4 -2 -35z"/>
<path d="M4905 5890 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M1362 5810 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M6012 5758 c35 -40 72 -82 83 -93 16 -16 108 -125 122 -144 2 -2 5
-2 8 1 7 7 -34 60 -102 132 -32 34 -80 87 -107 119 -27 31 -53 57 -58 57 -5 0
19 -33 54 -72z"/>
<path d="M1162 5778 c3 -7 13 -37 23 -66 9 -29 19 -52 21 -49 5 5 -36 127 -43
127 -3 0 -3 -6 -1 -12z"/>
<path d="M1372 5730 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M1382 5665 c0 -16 4 -43 8 -60 11 -42 11 -1 1 50 -7 34 -9 35 -9 10z"/>
<path d="M1407 5490 c3 -36 9 -67 13 -70 4 -3 10 -14 13 -25 9 -30 -2 32 -18
100 l-13 60 5 -65z"/>
<path d="M11408 5525 c-3 -14 -1 -25 3 -25 5 0 9 11 9 25 0 14 -2 25 -4 25 -2
0 -6 -11 -8 -25z"/>
<path d="M11376 5425 c-4 -15 -5 -30 -1 -33 3 -3 5 2 5 11 0 8 6 17 13 20 9 3
9 8 1 16 -9 10 -13 6 -18 -14z"/>
<path d="M6902 5320 c-61 -44 -172 -156 -223 -225 -24 -33 -49 -65 -55 -72 -6
-6 -17 -26 -24 -45 -8 -18 -17 -35 -20 -38 -20 -17 -90 -239 -109 -344 -12
-66 -13 -204 -2 -281 5 -40 8 -22 13 90 7 161 23 246 72 375 78 208 211 384
416 549 l25 20 -26 1 c-14 0 -45 -14 -67 -30z"/>
<path d="M8482 5320 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M11351 5274 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1445 5221 l1 -61 -30 0 c-51 0 -55 -8 -50 -95 21 -444 46 -764 68
-880 41 -215 75 -337 117 -413 16 -29 29 -60 29 -68 0 -8 3 -14 8 -14 4 0 12
-10 17 -22 6 -13 20 -24 32 -26 28 -4 151 55 164 79 5 11 15 19 22 19 6 0 32
22 57 49 45 48 46 52 44 105 -1 34 2 56 8 56 6 0 6 6 -2 15 -7 8 -10 15 -7 15
3 0 -5 12 -18 26 -14 15 -25 36 -26 48 0 12 -5 30 -10 41 -8 17 -8 15 -4 -7 3
-16 1 -28 -4 -28 -12 0 -23 29 -15 41 3 5 0 9 -5 9 -6 0 -11 7 -11 15 0 8 -4
15 -9 15 -8 0 -25 53 -24 77 0 7 -4 10 -9 7 -6 -4 -8 3 -4 17 3 13 3 18 0 11
-8 -17 -44 39 -51 77 -2 14 -11 39 -19 55 -8 16 -14 36 -15 45 0 12 -3 11 -9
-4 -9 -20 -10 -18 -15 20 -1 11 -12 49 -24 84 -11 35 -21 72 -21 82 0 9 -3 25
-6 34 -6 13 -9 14 -16 3 -5 -8 -6 -3 -2 14 4 20 2 29 -10 34 -9 3 -16 12 -16
19 0 7 -9 40 -20 75 -11 34 -17 67 -13 73 3 6 1 7 -6 3 -9 -6 -10 0 -6 21 4
18 3 23 -2 15 -11 -15 -33 91 -33 157 0 23 -9 61 -19 85 -11 23 -18 52 -15 63
3 12 -1 33 -8 48 -14 26 -14 24 -13 -34z m2 -93 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z"/>
<path d="M8370 5230 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8440 5176 c0 -2 6 -9 14 -15 10 -9 15 -8 19 2 3 8 -3 13 -14 14 -10
1 -19 0 -19 -1z"/>
<path d="M7448 4923 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7398 4913 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7262 4880 c-62 -22 -190 -86 -213 -106 -8 -8 -20 -14 -26 -14 -5 0
-18 -9 -28 -20 -28 -31 -10 -24 64 24 77 50 106 64 211 105 82 33 76 41 -8 11z"/>
<path d="M7448 4853 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7445 4830 c3 -5 -1 -10 -9 -10 -9 0 -16 -4 -16 -10 0 -5 10 -9 23
-9 32 2 85 16 65 18 -10 0 -18 6 -18 11 0 6 -12 10 -26 10 -14 0 -23 -4 -19
-10z"/>
<path d="M2585 4810 c10 -31 114 -240 119 -240 3 0 -12 37 -33 83 -21 45 -48
103 -60 130 -21 47 -38 65 -26 27z"/>
<path d="M7270 4800 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M7504 4789 c-194 -23 -331 -86 -466 -217 -62 -61 -71 -66 -106 -63
-44 3 -70 24 -74 59 -4 33 -26 40 -37 11 -12 -33 -2 -61 18 -54 11 3 27 -5 41
-20 20 -21 21 -25 6 -25 -9 0 -14 -4 -11 -10 15 -25 64 -9 121 39 117 100 281
183 430 217 104 24 303 25 392 1 154 -41 277 -105 410 -214 36 -29 73 -53 83
-53 27 0 89 58 89 83 0 21 0 21 -16 -1 -9 -13 -30 -24 -54 -28 -22 -4 -37 -10
-35 -15 3 -4 1 -10 -4 -13 -4 -3 -34 17 -65 44 -131 115 -257 181 -407 214
-93 20 -106 24 -69 25 25 1 70 -6 100 -14 92 -25 107 -26 51 -5 -117 43 -250
56 -397 39z"/>
<path d="M4776 4711 c-4 -5 0 -11 6 -14 27 -9 -3 -19 -67 -22 -40 -2 -71 -8
-75 -15 -5 -8 -18 -10 -32 -7 -30 8 -39 1 -60 -45 -14 -29 -24 -38 -43 -38
-14 0 -25 6 -25 13 0 6 -11 -12 -25 -42 -20 -43 -24 -64 -20 -107 l5 -54 -30
2 c-17 1 -30 8 -30 16 0 7 -5 10 -11 7 -5 -4 -9 -14 -7 -23 4 -20 -22 -19 468
-27 325 -6 363 -5 345 8 -28 20 -79 123 -69 138 5 8 2 10 -8 7 -9 -4 -28 5
-45 21 -23 21 -31 38 -36 81 -9 74 -20 81 -129 75 -83 -5 -88 -4 -88 15 0 21
-14 27 -24 11z"/>
<path d="M4972 4711 c-10 -6 -9 -10 7 -14 14 -3 21 0 21 9 0 16 -9 18 -28 5z"/>
<path d="M9113 4660 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M9946 4521 l-33 -68 -28 21 -29 21 24 -33 c29 -39 35 -40 48 -4 6 15
22 51 36 80 14 28 23 52 20 52 -3 0 -20 -31 -38 -69z"/>
<path d="M7528 4543 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2760 4511 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M7458 4486 c-20 -6 -43 -17 -50 -24 -6 -6 -21 -12 -32 -12 -20 0 -20
0 0 -15 18 -14 18 -14 -8 -15 -16 0 -28 -5 -28 -11 0 -8 16 -9 48 -5 42 5 44
4 22 -7 -45 -22 -130 -84 -123 -91 3 -3 -1 -6 -10 -6 -9 0 -17 -4 -17 -10 0
-5 -3 -9 -7 -9 -21 3 -33 -2 -33 -16 0 -24 -29 -33 -68 -19 -36 12 -45 21 -56
57 -14 43 -43 5 -31 -41 4 -15 10 -21 12 -14 3 6 8 12 12 12 16 0 48 -35 44
-47 -10 -27 45 -11 97 28 69 52 127 81 214 108 87 27 255 29 337 5 73 -22 185
-79 236 -120 43 -35 77 -42 103 -21 24 18 50 60 49 77 0 9 -4 6 -9 -7 -7 -16
-21 -24 -50 -29 -24 -4 -40 -12 -40 -20 0 -17 -26 -19 -36 -3 -3 6 -40 33 -80
59 -75 49 -158 82 -249 99 l-50 9 45 1 c25 0 70 -5 100 -13 72 -19 77 -12 8
10 -29 9 -102 19 -163 23 -87 5 -104 9 -80 16 28 8 224 -8 258 -21 8 -3 14 2
14 11 0 8 -5 15 -11 15 -6 0 -5 4 2 9 21 13 -8 30 -73 42 -41 7 -61 7 -68 0
-14 -14 -87 -14 -87 -1 0 13 -95 11 -142 -4z m212 -26 c0 -5 -17 -10 -37 -10
-28 0 -34 3 -23 10 20 13 60 13 60 0z"/>
<path d="M7310 4480 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M11282 4465 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M2791 4460 c14 -31 19 -36 19 -24 0 6 -7 19 -16 30 -14 18 -14 18 -3
-6z"/>
<path d="M7265 4460 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M7295 4414 c-23 -25 -24 -28 -8 -40 10 -7 24 -9 33 -4 8 4 21 5 28 3
6 -3 12 0 12 6 0 6 -6 11 -14 11 -22 0 -30 19 -16 35 23 27 -9 17 -35 -11z"/>
<path d="M7940 4412 c0 -5 -10 -13 -22 -19 -15 -6 -18 -12 -10 -17 7 -4 12 -2
12 3 0 6 5 11 11 11 6 0 9 -6 6 -14 -7 -18 15 -27 34 -14 11 8 10 9 -3 4 -20
-6 -25 10 -5 17 6 3 3 6 -8 6 -15 1 -17 3 -6 10 9 6 10 11 2 15 -6 4 -11 3
-11 -2z"/>
<path d="M2830 4389 c6 -10 5 -20 -2 -27 -18 -18 5 -15 41 6 41 23 39 29 -8
34 -34 3 -38 1 -31 -13z"/>
<path d="M4000 4319 c0 -37 1 -39 16 -25 8 9 21 16 27 16 7 0 4 -7 -5 -14 -10
-7 -18 -16 -18 -20 0 -3 354 -5 787 -4 659 3 787 5 791 17 4 11 -4 12 -34 8
-23 -4 -31 -3 -20 2 41 16 -9 22 -286 32 -253 10 -1120 5 -1182 -7 -14 -2 -30
4 -41 16 -27 30 -35 25 -35 -21z m273 -16 c-40 -2 -106 -2 -145 0 -40 1 -8 3
72 3 80 0 112 -2 73 -3z"/>
<path d="M10635 4305 c-34 -75 -25 -83 10 -10 14 31 24 59 21 62 -3 4 -17 -20
-31 -52z"/>
<path d="M6481 4234 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10597 4223 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M10466 4183 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M10569 4168 c-6 -12 -15 -25 -19 -28 -8 -7 -40 -76 -40 -87 0 -4 8 1
16 12 23 30 66 116 60 122 -2 3 -10 -6 -17 -19z"/>
<path d="M10447 4153 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M7560 4143 c-48 -8 -117 -34 -136 -51 -10 -9 -32 -24 -47 -32 -25
-12 -28 -19 -24 -47 3 -18 2 -33 -2 -33 -12 0 -41 35 -41 48 0 7 -7 12 -15 12
-10 0 -15 -10 -15 -31 0 -16 4 -28 9 -25 17 11 43 -6 38 -25 -8 -30 29 -24 87
15 66 44 134 66 199 66 60 0 136 -21 175 -48 36 -25 52 -34 52 -29 0 12 -93
67 -135 80 l-50 15 61 -1 c34 -1 58 -4 53 -7 -9 -6 52 -43 61 -38 3 2 13 -4
22 -12 11 -10 13 -19 6 -27 -13 -16 -1 -33 23 -33 25 0 59 34 59 60 l0 20 -20
-20 c-27 -27 -36 -25 -52 11 -7 17 -31 41 -53 55 -22 13 -33 24 -25 24 12 1
11 3 -3 11 -9 5 -22 7 -29 3 -6 -4 -8 -3 -5 3 12 20 -131 46 -193 36z m255
-93 c-3 -5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z"/>
<path d="M7378 4115 c-34 -23 -56 -45 -44 -45 3 0 26 16 52 35 52 40 47 46 -8
10z"/>
<path d="M9646 4119 c-15 -22 -13 -39 5 -39 5 0 8 3 7 8 0 4 2 15 7 25 12 27
-1 31 -19 6z"/>
<path d="M9674 4105 c-4 -8 -1 -21 5 -29 6 -7 8 -16 4 -20 -4 -4 0 -4 10 0 9
3 17 1 17 -4 0 -6 9 -14 20 -17 40 -13 90 -70 90 -103 0 -31 -41 -82 -66 -82
-6 0 -54 29 -106 64 l-96 63 -12 -25 c-6 -14 -7 -28 -3 -31 89 -66 200 -131
225 -131 41 0 86 26 108 63 26 42 25 54 -2 31 -13 -10 -17 -12 -10 -4 14 16
16 78 3 113 -8 19 -157 127 -177 127 -2 0 -7 -7 -10 -15z m-83 -202 c13 -15
12 -15 -8 -4 -24 12 -29 21 -14 21 5 0 15 -7 22 -17z"/>
<path d="M10418 4098 c-28 -42 -50 -90 -39 -83 12 6 65 105 57 105 -2 0 -10
-10 -18 -22z"/>
<path d="M11219 4079 c-6 -24 -13 -64 -15 -88 -2 -24 -7 -49 -12 -55 -14 -18
-33 -96 -27 -106 3 -6 1 -10 -4 -10 -6 0 -11 -8 -11 -17 0 -10 -7 -31 -15 -47
-8 -15 -15 -37 -15 -47 0 -24 -9 -44 -116 -264 -98 -201 -117 -231 -191 -308
-54 -56 -85 -76 -91 -59 -3 11 -72 -33 -80 -50 -2 -5 -8 -8 -13 -8 -6 0 -19
-9 -31 -20 -38 -35 -44 -22 -8 16 77 78 94 103 103 152 11 57 -25 105 -63 82
-15 -9 -60 11 -60 27 0 7 -12 24 -27 38 -15 14 -22 25 -15 25 7 0 10 5 7 10
-4 6 -11 8 -16 5 -5 -4 -9 -3 -9 2 0 7 -40 13 -102 16 -10 1 -18 4 -18 8 0 10
-65 -6 -87 -22 -23 -17 -94 -95 -153 -169 -25 -30 -61 -73 -82 -95 -21 -22
-38 -47 -38 -56 0 -10 -7 -16 -17 -15 -15 1 -18 -7 -17 -41 0 -24 -3 -43 -8
-43 -4 0 -8 -36 -8 -80 0 -47 4 -80 10 -80 6 0 10 7 10 16 0 13 3 14 15 4 8
-7 12 -16 10 -21 -7 -11 31 -31 52 -27 10 2 18 -3 18 -12 0 -21 37 -17 100 10
28 11 29 13 10 21 -17 8 -16 8 6 4 17 -3 35 2 52 15 14 11 30 20 35 20 13 0
72 31 90 48 7 6 18 12 23 12 17 0 8 -15 -21 -35 -161 -110 -216 -142 -350
-207 -85 -41 -209 -99 -275 -129 -122 -54 -242 -114 -372 -184 -40 -22 -76
-35 -80 -31 -4 5 -2 11 5 13 20 7 14 33 -10 42 -18 7 -28 3 -45 -15 -24 -26
-48 -31 -56 -11 -3 6 -6 2 -6 -11 -1 -13 -5 -21 -10 -18 -4 3 -17 -2 -27 -10
-19 -15 -19 -15 1 -9 18 6 18 5 -2 -15 -13 -11 -23 -26 -23 -31 0 -6 -7 -9
-15 -5 -17 6 -19 -3 -5 -24 9 -13 12 -13 21 3 7 12 17 15 35 11 13 -3 24 -2
24 3 0 4 10 14 23 22 20 12 20 11 -3 -12 -14 -14 -43 -35 -65 -46 -40 -21 -40
-21 -43 -1 -4 21 -17 27 -26 11 -3 -5 -18 -11 -33 -14 -26 -5 -26 -4 -8 9 10
8 22 14 27 14 4 0 8 7 8 16 0 14 -6 12 -32 -8 -18 -13 -45 -30 -61 -37 -15 -8
-23 -17 -17 -21 11 -7 -14 -68 -26 -62 -3 2 -8 1 -11 -2 -4 -3 2 -6 13 -6 18
-1 18 -1 0 -11 -14 -9 -15 -13 -6 -19 8 -5 21 1 35 16 18 19 24 21 28 10 3 -8
2 -16 -3 -18 -5 -2 -116 -106 -247 -233 -332 -322 -335 -325 -340 -325 -3 0
-14 -11 -25 -25 -11 -14 -28 -25 -38 -25 -9 0 -23 -7 -30 -15 -24 -29 -208
-141 -217 -131 -2 2 9 12 26 22 29 17 35 29 33 63 0 8 6 20 14 28 18 18 18 28
-1 47 -8 8 -15 30 -15 48 0 30 -5 35 -45 51 -25 11 -42 23 -39 28 7 12 -69 12
-82 -1 -6 -6 -15 -6 -24 0 -12 8 -11 10 7 10 12 0 24 4 27 8 2 4 -15 8 -40 8
-24 0 -44 -4 -44 -9 0 -5 -9 -6 -20 -2 -11 3 -34 -1 -52 -9 -52 -24 -269 -88
-368 -109 -52 -11 -156 -39 -175 -47 -11 -5 -33 -11 -50 -13 -16 -3 -79 -15
-140 -27 -60 -11 -139 -27 -175 -33 -37 -7 -64 -17 -63 -24 2 -7 -11 -9 -37
-6 l-40 6 0 -37 c0 -25 -4 -36 -15 -36 -10 0 -15 -10 -15 -30 0 -20 5 -30 15
-30 18 0 20 -17 3 -23 -7 -2 -2 -5 12 -5 14 0 45 -6 70 -12 25 -7 62 -12 82
-12 22 0 36 -5 35 -11 -1 -6 9 -13 23 -15 14 -2 27 -7 30 -11 5 -7 78 -22 230
-45 75 -11 294 -6 355 9 58 14 11 -12 -65 -36 -61 -19 -97 -23 -195 -24 -66 0
-149 4 -185 8 -36 5 -62 6 -59 2 8 -7 321 -37 364 -34 17 1 44 1 60 -1 l30 -2
-30 -8 c-16 -4 -22 -8 -12 -9 32 -2 170 30 262 61 93 31 305 135 305 150 0 4
5 8 11 8 25 0 185 115 253 183 26 25 46 44 46 42 0 -1 17 14 38 34 22 20 74
68 117 106 43 39 113 102 155 140 358 330 636 524 1006 701 526 251 616 301
809 444 78 59 237 212 315 305 85 101 208 319 250 442 16 48 41 122 55 163 14
41 25 84 25 96 0 11 6 34 14 50 8 16 17 47 20 69 3 22 10 64 16 93 15 65 6 81
-11 21z m-2189 -1929 c0 -5 -7 -10 -16 -10 -8 0 -12 5 -9 10 3 6 10 10 16 10
5 0 9 -4 9 -10z m58 -9 c11 -6 8 -13 -13 -29 -39 -31 -66 -14 -42 26 9 14 36
16 55 3z m-908 -711 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6
0 10 -4 10 -10z m-90 -164 c0 -2 -24 -16 -52 -31 -29 -15 -64 -36 -77 -46 -28
-23 -48 -25 -31 -4 17 21 76 56 119 71 42 15 41 15 41 10z m-370 -176 c-8 -5
-22 -10 -30 -10 -13 0 -13 1 0 10 8 5 22 10 30 10 13 0 13 -1 0 -10z"/>
<path d="M3071 4041 c-11 -7 -11 -10 0 -15 8 -3 1 -4 -16 -1 -17 3 -25 2 -18
-2 8 -6 9 -14 3 -23 -17 -26 -11 -34 11 -14 30 27 54 8 54 -42 1 -52 11 -69
32 -52 14 11 15 10 9 -10 -9 -28 8 -29 28 0 15 22 12 43 -5 33 -5 -4 -9 5 -9
19 0 37 0 38 -22 69 -24 34 -50 48 -67 38z m46 -27 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z m33 -80 c0 -14 -4 -23 -10 -19 -5 3 -11 -2 -11
-12 -1 -16 -2 -16 -6 -1 -4 16 12 58 22 58 3 0 5 -12 5 -26z"/>
<path d="M10490 4020 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M2975 3960 c2 -30 7 -67 10 -81 5 -17 2 -31 -8 -40 -13 -12 -12 -15
1 -25 13 -9 13 -12 -2 -17 -9 -4 -15 -3 -12 2 3 5 -8 11 -24 14 -42 9 -52 34
-60 147 -1 26 -40 -30 -40 -59 0 -33 19 -67 21 -36 0 17 2 16 11 -5 5 -14 14
-33 19 -42 5 -10 9 -24 9 -33 0 -34 78 -47 118 -19 32 22 45 51 27 57 -10 4
-12 1 -9 -11 5 -15 3 -14 -10 2 -8 10 -20 15 -26 11 -9 -6 -9 -2 0 15 6 12 9
32 6 44 -5 20 -4 20 9 2 8 -10 12 -23 9 -27 -3 -5 0 -9 5 -9 6 0 11 1 11 3 0
17 -31 141 -36 145 -4 4 -4 -1 -1 -11 4 -10 4 -31 0 -45 -7 -25 -8 -23 -20 23
l-13 50 5 -55z"/>
<path d="M10357 3993 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M10333 3948 c-15 -18 -35 -58 -29 -58 2 0 13 16 25 35 20 35 22 46 4
23z"/>
<path d="M9891 3924 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8592 3895 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15
-21z"/>
<path d="M10266 3838 l-18 -33 21 25 c18 22 26 40 18 40 -1 0 -11 -15 -21 -32z"/>
<path d="M3219 3844 c-12 -15 -11 -16 8 -10 18 6 25 1 37 -23 18 -33 22 -67 6
-41 -5 8 -12 11 -16 7 -4 -3 -2 -13 5 -20 9 -11 8 -17 -3 -27 -9 -6 -19 -9
-25 -6 -5 3 -20 -3 -32 -15 -13 -11 -18 -18 -11 -14 15 8 16 -7 2 -21 -7 -7
-6 -11 4 -11 8 0 13 4 10 9 -3 4 0 8 6 8 21 0 5 -22 -43 -57 -34 -26 -47 -31
-47 -19 0 10 -6 13 -15 10 -8 -4 -15 -1 -15 5 0 7 -9 5 -25 -5 l-25 -16 23
-29 c25 -32 31 -34 49 -16 7 7 50 41 96 75 55 43 90 62 105 60 15 -2 21 2 19
12 -1 9 6 6 18 -9 16 -18 18 -27 9 -37 -9 -11 -8 -14 3 -14 26 0 37 20 22 39
-8 9 -28 33 -46 54 -22 27 -33 35 -39 26 -4 -7 -5 -17 -2 -23 3 -5 1 -6 -5 -2
-9 5 -9 13 -2 27 9 16 5 27 -17 59 -32 45 -35 46 -54 24z m11 -134 c0 -5 -5
-10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M7552 3833 c-6 -2 -10 -9 -7 -13 3 -5 -7 -16 -23 -24 -30 -15 -62
-70 -62 -103 1 -22 28 -83 29 -65 1 9 16 2 42 -19 26 -20 36 -34 29 -39 -16
-10 12 -20 56 -20 69 0 145 67 143 126 -1 24 -3 25 -6 7 -5 -28 -9 -28 -56 -4
-57 29 -64 38 -78 92 -11 43 -16 49 -38 49 -21 0 -23 2 -11 10 16 10 4 12 -18
3z"/>
<path d="M9461 3802 c-29 -5 -55 -28 -46 -41 3 -5 1 -12 -5 -16 -5 -3 -10 -11
-10 -17 0 -7 4 -7 14 1 11 9 12 6 8 -16 l-5 -28 32 34 c28 30 36 33 71 28 23
-3 38 -1 34 4 -8 13 9 11 30 -4 9 -7 21 -32 27 -55 11 -50 -7 -104 -40 -122
-12 -6 -19 -16 -15 -21 10 -18 -66 -1 -96 21 -29 20 -60 84 -60 123 -1 20 -2
20 -11 4 -5 -9 -7 -22 -4 -27 3 -6 1 -10 -4 -10 -6 0 -11 12 -11 28 -1 24 -2
25 -11 9 -18 -31 14 -143 39 -134 4 1 21 -9 37 -22 29 -23 29 -23 5 -17 -16 4
-11 -1 14 -15 48 -26 123 -22 164 8 32 24 75 104 70 130 -3 12 -9 4 -18 -24
-7 -23 -24 -53 -37 -65 l-25 -23 26 45 c72 126 -22 248 -173 222z m165 -217
c-9 -14 -21 -25 -27 -25 -6 0 -1 12 10 26 12 15 22 34 22 43 1 13 2 12 6 -2 3
-10 -3 -29 -11 -42z"/>
<path d="M10215 3759 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M10179 3703 c-29 -35 -41 -53 -36 -53 2 0 17 16 31 35 28 36 31 49 5
18z"/>
<path d="M10079 3567 c-95 -124 -115 -153 -95 -137 22 17 159 200 154 206 -2
2 -29 -29 -59 -69z"/>
<path d="M6600 3595 c0 -24 4 -31 20 -31 25 0 25 4 0 36 l-20 25 0 -30z"/>
<path d="M6640 3613 c0 -6 8 -17 18 -24 16 -13 16 -13 2 6 -8 11 -16 22 -17
24 -2 2 -3 0 -3 -6z"/>
<path d="M9250 3580 c-19 -19 -19 -22 -4 -58 25 -59 44 -112 38 -112 -2 0 -37
9 -76 20 -72 20 -73 20 -92 0 -11 -11 -18 -21 -15 -23 2 -2 51 -16 109 -31 58
-16 113 -34 124 -42 15 -10 23 -11 35 -2 9 7 13 8 8 3 -4 -4 1 -17 10 -28 18
-19 17 -20 -7 -7 l-25 12 23 -23 22 -23 27 27 c22 22 24 27 10 27 -33 0 -91
65 -111 124 -11 31 -23 53 -29 49 -6 -3 -7 -2 -4 4 3 5 1 27 -5 49 -6 21 -11
42 -10 47 3 12 -7 8 -28 -13z m105 -240 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14
6 0 13 -4 16 -10z"/>
<path d="M6615 3540 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3445 3532 c-6 -5 -46 -23 -90 -40 -96 -37 -145 -62 -125 -63 8 0 4
-5 -10 -11 l-25 -10 23 -11 c16 -7 29 -7 46 1 22 10 28 7 62 -34 32 -40 35
-48 25 -70 -9 -20 -8 -30 2 -45 14 -19 14 -19 32 1 10 11 15 20 11 20 -3 0 0
10 8 23 8 12 17 41 19 64 2 24 15 60 29 80 14 21 27 44 30 51 2 10 7 10 23 -2
15 -10 17 -17 8 -27 -6 -8 -27 -45 -47 -84 -20 -38 -48 -90 -62 -113 -14 -24
-23 -46 -20 -50 8 -8 8 -8 66 98 74 134 102 191 96 198 -3 2 -8 -3 -12 -12 -5
-14 -11 -12 -37 14 -33 32 -38 34 -52 22z m-16 -104 c-13 -24 -22 -51 -20 -60
1 -10 0 -18 -3 -18 -8 0 -76 72 -76 80 0 3 23 14 50 24 28 10 53 23 57 29 5 8
8 8 10 0 2 -6 -6 -31 -18 -55z m-55 -170 c-9 -14 -23 2 -17 18 4 12 8 13 14 3
4 -7 5 -17 3 -21z"/>
<path d="M6550 3496 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M3475 3451 c-8 -17 -12 -31 -7 -31 12 0 37 48 29 56 -3 3 -13 -8 -22
-25z"/>
<path d="M1650 3441 c5 -11 15 -23 21 -27 6 -3 3 5 -6 20 -20 30 -30 35 -15 7z"/>
<path d="M3176 3441 c-3 -5 1 -11 9 -14 9 -4 12 -1 8 9 -6 16 -10 17 -17 5z"/>
<path d="M1600 3420 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3622 3399 c-5 -13 -20 -64 -33 -114 -19 -74 -30 -97 -61 -129 -29
-31 -35 -42 -26 -53 6 -8 17 -12 24 -9 8 3 11 0 7 -10 -10 -26 13 -14 57 31
36 37 59 50 115 66 142 41 160 52 108 62 -30 6 -55 -1 -48 -13 3 -4 -5 -10
-18 -14 -33 -9 -44 -7 -27 5 11 7 2 8 -32 5 -28 -3 -48 0 -48 5 0 6 5 7 10 4
6 -3 10 1 10 10 0 10 -6 15 -13 12 -10 -4 -12 4 -9 27 2 23 1 27 -7 16 -19
-28 -22 -2 -6 55 17 56 14 90 -3 44z m-20 -236 c2 1 -8 -10 -23 -25 -15 -14
-27 -28 -26 -30 1 -2 -3 2 -9 9 -8 10 -14 10 -24 0 -11 -10 -11 -8 0 8 34 48
42 55 60 45 10 -5 19 -8 22 -7z"/>
<path d="M3551 3153 c-7 -8 -11 -16 -8 -19 2 -2 10 2 17 11 17 20 9 27 -9 8z"/>
<path d="M1630 3382 c6 -13 14 -21 18 -18 3 4 -2 14 -12 24 -18 16 -18 16 -6
-6z"/>
<path d="M6660 3375 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25
-28 25 -3 0 5 -11 18 -25z"/>
<path d="M3640 3380 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3672 3333 c-15 -48 -8 -55 8 -8 7 20 10 38 8 41 -3 2 -10 -13 -16
-33z"/>
<path d="M6743 3302 c4 -6 22 -21 39 -34 17 -12 28 -17 25 -10 -4 6 -22 21
-39 34 -17 12 -28 17 -25 10z"/>
<path d="M7768 3273 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M8895 3215 c-38 -35 -73 -64 -77 -65 -14 0 -8 -18 7 -23 8 -4 17 -1
21 5 4 7 3 8 -4 4 -19 -12 -14 9 7 28 29 26 36 2 11 -34 -26 -36 -13 -39 26
-5 l29 25 50 -56 c29 -32 59 -56 72 -57 12 -1 20 -4 17 -8 -2 -4 3 -12 12 -19
8 -7 13 -19 10 -26 -9 -23 7 -24 31 -2 26 24 30 40 9 32 -8 -3 -26 11 -44 33
-17 22 -51 61 -76 89 -25 27 -46 55 -46 62 0 7 4 11 8 8 5 -3 22 8 37 24 32
34 23 41 -11 9 -19 -18 -22 -18 -28 -4 -3 9 -2 13 3 10 5 -3 13 0 17 6 4 8 3
9 -4 5 -7 -4 -12 -3 -12 3 0 5 6 12 13 14 6 3 8 6 2 6 -5 0 -41 -28 -80 -64z
m70 -95 c9 -16 13 -30 11 -30 -3 0 -12 14 -21 30 -9 17 -13 30 -11 30 3 0 12
-13 21 -30z"/>
<path d="M6857 3219 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6900 3185 c14 -8 30 -14 35 -14 6 0 -1 6 -15 14 -14 8 -29 14 -35
14 -5 0 1 -6 15 -14z"/>
<path d="M6950 3165 c0 -7 78 -45 92 -45 7 1 -7 12 -32 25 -45 24 -60 29 -60
20z"/>
<path d="M9860 3149 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9772 3057 c-31 -33 -27 -43 5 -13 15 14 25 28 22 31 -3 3 -15 -5
-27 -18z"/>
<path d="M3975 3034 c-16 -8 -34 -20 -40 -26 -7 -8 -6 -9 4 -3 10 6 12 4 7 -4
-6 -9 -11 -9 -24 1 -13 12 -14 10 -8 -17 l8 -30 -20 23 -20 23 -21 -30 c-25
-35 -28 -102 -6 -125 8 -8 15 -17 15 -20 0 -10 54 -63 77 -75 28 -14 75 -14
108 1 33 15 32 25 -5 33 -18 4 -27 11 -24 17 7 11 -12 8 -47 -6 -20 -8 -64 26
-85 66 -15 29 -11 88 6 88 4 0 6 -9 3 -20 -8 -32 14 -23 25 10 12 32 64 70 97
70 17 0 17 2 5 10 -21 14 3 13 34 -1 27 -13 40 -46 30 -83 -4 -18 1 -27 27
-44 37 -23 50 -21 48 11 -1 17 -2 18 -6 5 -5 -20 -18 -23 -28 -8 -3 6 -1 10 4
10 16 0 13 19 -9 66 -16 32 -31 46 -61 58 -49 20 -57 20 -94 0z m-91 -78 c-3
-9 -10 -16 -15 -16 -6 0 -5 9 1 21 13 24 24 20 14 -5z"/>
<path d="M8675 3036 c-11 -8 -15 -16 -10 -16 6 0 -5 -9 -23 -20 -87 -53 -63
-194 41 -247 55 -28 101 -26 155 7 42 26 63 61 68 112 3 40 3 41 -5 10 -13
-50 -19 -48 -14 5 8 88 -46 148 -144 159 -35 4 -53 1 -68 -10z m125 -58 c30
-7 36 -17 38 -68 2 -49 -1 -55 -34 -86 -20 -20 -46 -34 -60 -34 -32 0 -72 26
-88 59 -18 36 -28 91 -16 91 6 0 10 -8 10 -17 1 -11 6 -5 14 13 22 51 58 62
136 42z m-183 -80 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z
m253 -48 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
-10z m10 -24 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10
-2 10 -4z m-200 -52 c0 -2 -9 0 -20 6 -11 6 -20 13 -20 16 0 2 9 0 20 -6 11
-6 20 -13 20 -16z"/>
<path d="M1980 2995 c13 -14 26 -25 28 -25 3 0 -5 11 -18 25 -13 14 -26 25
-28 25 -3 0 5 -11 18 -25z"/>
<path d="M9720 2999 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9960 2979 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9690 2969 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2120 2951 c14 -12 30 -25 36 -30 17 -14 80 -44 69 -33 -5 5 -37 26
-70 47 -33 20 -49 27 -35 16z"/>
<path d="M9647 2933 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M2101 2907 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24 17
-6 0 -8 -1 -6 -3z"/>
<path d="M2270 2851 c14 -11 48 -32 75 -46 31 -16 41 -20 28 -8 -13 10 -47 31
-75 46 -37 20 -45 22 -28 8z"/>
<path d="M4251 2859 c-17 -7 -22 -15 -18 -29 3 -11 0 -18 -6 -17 -6 1 -11 -2
-12 -8 0 -5 -4 -16 -9 -24 -6 -10 -5 -12 2 -7 8 5 10 -3 6 -26 l-6 -33 27 38
c14 21 38 42 51 48 36 13 90 11 101 -3 26 -33 4 -144 -35 -175 -15 -13 -15
-13 6 -3 13 6 30 27 39 46 14 28 19 31 26 19 9 -17 27 -11 27 8 0 7 -4 6 -10
-3 -6 -9 -10 -10 -10 -3 0 6 5 15 10 18 16 10 12 43 -8 63 -10 10 -17 25 -14
33 3 12 2 12 -6 0 -8 -11 -11 -9 -17 9 -11 34 -101 66 -144 49z"/>
<path d="M3080 2845 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z"/>
<path d="M8375 2814 c-9 -14 -19 -23 -22 -20 -3 3 -12 -2 -20 -12 -8 -9 -11
-11 -7 -3 4 8 3 12 -3 8 -5 -3 -15 -24 -23 -46 -11 -33 -10 -46 3 -85 16 -47
40 -79 54 -74 4 2 12 -7 18 -19 10 -24 32 -33 85 -33 70 0 150 68 150 128 0
25 -1 25 -14 7 -13 -18 -14 -18 -9 8 3 16 -2 44 -12 67 l-17 38 -44 -26 c-24
-15 -44 -31 -44 -35 0 -5 5 -5 12 -1 7 4 8 3 4 -5 -4 -6 -16 -9 -27 -6 -22 7
-24 -3 -4 -28 13 -18 15 -18 44 -1 36 21 48 13 35 -23 -11 -33 -77 -73 -108
-65 -29 7 -57 38 -72 81 -13 38 -9 56 6 31 7 -11 10 -6 10 18 0 26 7 36 33 53
18 11 43 18 56 15 14 -2 35 3 46 12 l22 16 -25 13 c-13 7 -44 13 -67 13 -35 0
-46 -5 -60 -26z"/>
<path d="M2230 2820 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M9535 2820 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2270 2797 c18 -17 139 -84 125 -69 -5 6 -39 27 -75 47 -36 20 -58
30 -50 22z"/>
<path d="M4152 2765 c-19 -42 -10 -144 9 -113 7 10 9 8 9 -6 0 -10 20 -38 45
-62 38 -37 51 -44 85 -44 48 0 85 17 121 57 32 34 49 66 49 90 -1 11 -7 4 -16
-17 -12 -28 -17 -32 -25 -20 -9 12 -10 11 -5 -4 6 -19 -9 -46 -25 -46 -5 0 -9
5 -9 11 0 5 5 7 10 4 6 -3 10 1 10 10 0 13 -7 11 -33 -9 -19 -15 -40 -26 -48
-26 -8 0 -21 -6 -28 -12 -11 -10 -14 -10 -18 0 -3 6 -10 12 -17 12 -22 0 -64
49 -71 82 -5 20 -10 26 -15 18 -10 -16 -23 54 -15 80 9 28 0 25 -13 -5z m105
-191 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M2400 2775 c0 -2 15 -12 33 -20 l32 -16 -25 20 c-24 20 -40 26 -40
16z"/>
<path d="M9690 2720 c-19 -16 -31 -30 -27 -30 4 0 22 13 40 30 41 38 33 38
-13 0z"/>
<path d="M4505 2595 l-67 -139 22 -18 c13 -10 27 -17 33 -15 5 1 28 38 50 82
l41 80 8 -38 c4 -20 11 -71 15 -114 5 -51 13 -78 22 -81 8 -3 11 0 7 6 -10 17
18 21 34 4 13 -14 12 -15 -4 -9 -12 5 -16 3 -14 -5 3 -7 12 -14 22 -16 12 -3
32 29 82 133 37 75 64 138 61 141 -3 3 -31 -44 -62 -106 -32 -61 -59 -109 -62
-106 -2 2 3 16 12 30 10 14 13 26 9 26 -5 0 -4 4 2 8 10 7 44 74 44 87 0 4 -9
-3 -20 -16 -10 -13 -19 -19 -20 -13 0 5 5 15 12 22 7 7 8 12 4 12 -5 0 -4 6 2
13 16 19 33 67 23 67 -9 0 -86 -149 -86 -168 0 -8 -7 -17 -15 -22 -12 -7 -16
-3 -16 13 -1 77 -5 118 -12 113 -4 -2 -6 17 -5 42 4 60 -4 92 -22 92 -8 0 -18
8 -24 17 -7 14 -23 -10 -76 -122z m19 -97 c-14 -29 -27 -54 -28 -55 -1 -1 -12
0 -24 4 l-22 5 27 49 c25 47 49 67 36 32 -3 -12 1 -10 12 5 28 38 28 18 -1
-40z m103 -45 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z"/>
<path d="M4470 2471 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M2430 2705 c0 -2 18 -14 40 -25 22 -11 40 -18 40 -15 0 2 -18 14 -40
25 -22 11 -40 18 -40 15z"/>
<path d="M2596 2665 c10 -8 23 -15 28 -15 6 0 1 7 -10 15 -10 8 -23 15 -28 15
-6 0 -1 -7 10 -15z"/>
<path d="M9589 2633 c-29 -27 -60 -55 -69 -63 -8 -8 -40 -35 -70 -60 -30 -24
-71 -60 -90 -78 l-35 -34 45 30 c25 17 52 39 61 49 9 10 38 36 64 58 71 59
161 145 153 145 -3 0 -30 -21 -59 -47z"/>
<path d="M2520 2656 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M8042 2641 c-18 -9 -29 -20 -25 -25 4 -4 1 -7 -7 -5 -8 1 -28 -3 -43
-9 -16 -7 -33 -12 -38 -12 -5 0 -9 -4 -9 -10 0 -18 74 -159 81 -154 4 2 10 -3
13 -12 3 -8 2 -12 -4 -9 -15 9 -12 -1 9 -41 12 -22 21 -30 25 -22 3 7 3 1 0
-14 -4 -16 -2 -28 2 -28 23 0 174 75 174 87 0 7 -6 13 -14 13 -8 0 -16 5 -18
12 -5 14 -65 -6 -83 -27 -13 -15 -42 -15 -42 -1 0 6 -3 22 -7 36 -6 23 -1 28
51 52 51 23 55 27 36 33 -13 4 -23 13 -23 21 0 10 -7 10 -37 -3 -21 -8 -41
-19 -44 -25 -7 -11 -24 9 -33 38 -5 17 2 24 46 44 29 13 55 25 57 27 8 5 -22
33 -30 27 -5 -3 -6 2 -3 10 7 19 8 19 -34 -3z m68 -131 c0 -5 -5 -10 -11 -10
-5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M2675 2625 c11 -9 59 -36 107 -61 47 -24 122 -64 165 -90 103 -61
124 -70 88 -40 -16 14 -34 26 -39 26 -4 0 -34 15 -65 34 -83 50 -279 150 -256
131z"/>
<path d="M2618 2600 c41 -25 54 -25 23 0 -13 11 -31 20 -40 20 -9 0 -3 -8 17
-20z"/>
<path d="M9230 2570 c-14 -11 -20 -20 -14 -20 14 0 50 27 44 33 -3 3 -16 -3
-30 -13z"/>
<path d="M2675 2570 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M4863 2524 c-12 -33 -37 -98 -56 -147 l-36 -87 29 -15 c16 -8 31 -15
34 -15 2 0 19 35 36 78 18 42 36 81 40 85 7 8 16 -34 36 -160 4 -24 12 -47 19
-53 19 -16 75 -24 75 -11 0 6 23 68 50 137 28 69 50 131 50 137 0 23 -18 -10
-44 -83 -15 -41 -34 -86 -42 -100 l-15 -25 5 27 c4 15 2 30 -4 33 -5 3 -10 -2
-11 -12 0 -10 -3 -13 -5 -6 -3 7 0 22 6 34 10 17 14 19 22 8 7 -10 7 -7 3 9
-4 15 -2 22 6 20 6 -2 22 21 35 50 19 42 21 52 9 52 -8 0 -15 5 -15 10 0 6 -3
10 -8 10 -9 0 -27 -41 -57 -127 -13 -35 -25 -66 -28 -69 -9 -9 -25 52 -38 144
-11 78 -16 93 -33 98 -12 4 -26 14 -32 22 -8 11 -15 2 -31 -44z m42 -41 c-5
-10 -7 -22 -6 -28 2 -5 -1 -7 -4 -3 -4 4 -9 23 -10 43 -2 32 0 35 13 21 10 -9
12 -21 7 -33z m22 5 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
m-61 -25 c-8 -15 -15 -25 -16 -21 0 12 23 58 27 54 3 -2 -2 -17 -11 -33z m-14
-127 c-13 -35 -20 -43 -39 -42 -28 1 -28 3 -3 41 11 17 20 23 20 15 0 -10 5
-7 16 8 22 32 23 27 6 -22z"/>
<path d="M9182 2554 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M2715 2553 c6 -6 42 -26 80 -47 39 -20 61 -29 50 -20 -23 18 -145 81
-130 67z"/>
<path d="M9140 2540 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7813 2414 c2 -68 2 -124 -2 -124 -4 0 -36 38 -71 84 -61 80 -67 85
-104 85 -33 1 -37 -1 -26 -14 7 -8 16 -12 21 -9 5 3 8 1 7 -5 -2 -6 8 -21 22
-33 14 -13 19 -19 10 -13 -20 12 24 -40 73 -87 21 -21 36 -42 32 -48 -4 -6 -1
-9 5 -8 7 2 14 -5 15 -15 5 -28 10 -29 54 -16 39 12 58 39 27 39 -12 0 -15 23
-15 123 0 136 -3 153 -33 160 -19 5 -20 2 -15 -119z"/>
<path d="M9120 2482 c0 -11 -49 -34 -59 -27 -9 5 -51 -40 -51 -55 0 -6 -4 -10
-10 -10 -5 0 -10 8 -10 17 0 14 -3 14 -12 5 -10 -10 -10 -15 2 -22 8 -5 11
-12 8 -15 -4 -4 -13 -3 -20 1 -19 12 -48 15 -48 5 0 -5 6 -11 13 -14 9 -4 9
-7 -1 -18 -9 -10 -15 -11 -20 -3 -4 6 -15 11 -25 11 -12 0 -14 -4 -7 -11 12
-12 14 -29 2 -22 -4 2 -16 -2 -27 -10 -10 -8 -15 -14 -9 -14 5 -1 -4 -12 -21
-25 -16 -13 -27 -26 -25 -29 7 -6 253 160 303 205 23 21 36 38 30 39 -7 0 -13
-4 -13 -8z"/>
<path d="M2897 2449 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M5172 2333 c-64 -199 -68 -175 36 -206 49 -15 91 -27 94 -27 3 0 8 9
11 19 4 16 -6 22 -57 38 -58 19 -61 21 -63 54 -1 23 0 26 4 9 5 -24 5 -24 18
8 l14 31 48 -14 c37 -11 49 -12 55 -2 13 20 10 22 -47 42 -56 19 -63 26 -45
48 6 7 16 20 23 29 11 16 16 17 61 3 40 -12 51 -13 58 -3 13 21 9 31 -7 18
-14 -11 -19 -7 -16 12 1 6 -96 38 -118 38 -5 0 -14 7 -19 16 -6 12 -20 -19
-50 -113z m-2 -131 c0 -5 -6 -16 -13 -27 -10 -12 -16 -14 -21 -7 -4 7 -2 12 3
12 6 0 11 7 11 15 0 8 5 15 10 15 6 0 10 -4 10 -8z"/>
<path d="M7883 2380 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z"/>
<path d="M8995 2440 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7501 2413 c1 -10 4 -29 8 -43 l7 -25 17 31 c15 30 15 32 -1 30 -9 0
-16 5 -14 12 1 6 -2 12 -8 12 -5 0 -10 -8 -9 -17z"/>
<path d="M7363 2389 c-18 -5 -33 -14 -33 -19 0 -6 -11 -10 -24 -10 -14 0 -28
-5 -32 -11 -4 -8 -9 -7 -15 2 -7 12 -9 11 -9 -1 0 -16 61 -292 67 -299 3 -4
171 38 187 47 15 9 -37 41 -54 33 -8 -5 -31 -11 -51 -14 -36 -5 -37 -4 -47 33
-9 38 -9 39 22 49 17 5 43 12 59 15 15 4 27 10 27 15 0 15 -38 19 -81 10 -48
-11 -55 -7 -62 38 -5 32 -4 33 46 48 28 8 57 15 64 15 7 0 13 3 13 8 -1 8 -36
52 -42 51 -1 0 -18 -5 -35 -10z"/>
<path d="M9239 2341 c-19 -16 -20 -20 -8 -21 17 0 45 27 37 35 -3 3 -16 -3
-29 -14z"/>
<path d="M5451 2325 c-34 -29 -54 -80 -54 -137 0 -34 7 -45 59 -94 58 -55 59
-55 112 -51 42 3 59 10 80 32 l27 27 -28 -5 c-15 -2 -26 -2 -23 0 3 3 -1 11
-7 18 -10 11 -15 10 -29 -2 -9 -8 -33 -15 -53 -16 -48 -1 -75 27 -81 84 -2 24
-1 38 2 31 4 -8 13 2 26 27 21 43 56 63 103 59 36 -3 55 -19 55 -47 0 -17 6
-21 35 -21 l36 0 -36 48 c-47 60 -67 71 -137 72 -46 0 -62 -5 -87 -25z"/>
<path d="M7530 2340 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"/>
<path d="M7126 2268 c-3 -35 -7 -85 -9 -113 -1 -27 -6 -52 -11 -55 -4 -3 -22
29 -39 71 -39 94 -55 115 -88 123 -24 5 -27 3 -33 -32 -3 -20 -6 -59 -7 -87
-1 -27 -4 -63 -8 -79 -8 -41 -22 -22 -59 84 -28 80 -31 85 -61 88 l-31 3 34
-78 c18 -43 41 -104 51 -135 10 -32 22 -58 26 -58 5 0 9 -7 9 -16 0 -11 5 -14
16 -10 9 3 29 6 45 6 19 0 29 5 29 15 0 8 -4 15 -10 15 -12 0 -14 126 -2 133
4 3 6 -25 6 -61 -1 -46 1 -59 6 -42 4 14 8 51 9 83 1 31 5 57 10 57 5 0 19
-25 31 -55 25 -62 44 -82 35 -38 -5 26 -5 26 5 5 5 -13 7 -28 4 -33 -3 -6 0
-17 8 -26 7 -9 11 -19 9 -22 -3 -7 60 -2 72 6 4 2 6 28 5 56 l-1 52 -7 -45
c-6 -41 -7 -39 -8 25 0 85 15 147 18 75 3 -45 3 -44 10 15 16 125 8 182 -10
78 l-9 -48 2 45 c0 30 -3 44 -11 43 -7 -2 -12 2 -12 7 0 6 -4 10 -9 10 -5 0
-12 -28 -15 -62z"/>
<path d="M5760 2307 c0 -8 -2 -22 -6 -30 -4 -10 6 -16 36 -21 l40 -6 -6 -43
c-3 -23 -10 -66 -15 -96 -15 -90 -12 -121 11 -122 11 -1 25 -2 32 -3 6 -1 13
5 16 12 2 6 -3 12 -10 12 -10 0 -13 9 -10 30 5 34 21 51 23 23 1 -10 9 25 18
77 l16 95 43 -3 c34 -3 42 0 42 13 0 9 -4 13 -10 10 -5 -3 -10 0 -10 8 0 10
-26 18 -92 27 -51 7 -99 17 -105 23 -9 7 -13 5 -13 -6z m120 -158 c-4 -22 -11
-43 -15 -47 -5 -4 -5 1 -2 11 4 10 7 37 7 60 0 27 3 37 9 29 4 -7 5 -31 1 -53z"/>
<path d="M3220 2306 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z"/>
<path d="M3141 2297 c2 -2 20 -14 39 -26 l35 -23 -28 26 c-15 14 -33 26 -39
26 -6 0 -9 -1 -7 -3z"/>
<path d="M6036 2248 c-10 -65 -28 -279 -24 -284 11 -10 198 -17 198 -7 0 22
-39 43 -83 45 -47 3 -47 3 -47 39 0 44 13 51 75 42 35 -4 45 -3 45 9 0 25 -23
38 -67 38 -37 0 -43 3 -43 21 0 11 5 17 10 14 6 -4 10 5 10 19 0 25 2 26 60
26 56 0 60 2 59 23 0 12 -3 16 -6 10 -4 -10 -7 -10 -18 0 -7 8 -40 15 -76 16
-35 1 -69 7 -76 12 -9 8 -13 2 -17 -23z"/>
<path d="M6287 2195 c-4 -39 -7 -112 -7 -164 l0 -93 88 4 c128 6 182 45 188
137 3 43 2 43 -5 11 l-8 -35 -2 44 c-1 57 -36 117 -74 131 -17 5 -60 10 -98
10 -45 0 -69 4 -71 12 -3 7 -8 -19 -11 -57z m168 -9 c27 -11 29 -16 27 -57 -5
-78 -12 -99 -42 -114 -16 -8 -35 -12 -43 -9 -8 3 -18 1 -22 -5 -3 -6 -13 -11
-21 -11 -11 0 -14 19 -12 103 l2 102 6 -80 6 -80 2 83 2 82 33 0 c17 -1 45 -7
62 -14z m61 -168 c-9 -12 -16 -19 -16 -15 0 11 24 47 28 42 2 -2 -3 -14 -12
-27z"/>
<path d="M8735 2220 c3 -6 -5 -10 -18 -10 -13 0 -32 -9 -42 -20 -10 -11 -22
-20 -27 -20 -5 0 -25 -12 -43 -26 -19 -14 -39 -23 -44 -19 -7 4 -8 -1 -4 -11
4 -11 3 -15 -5 -10 -6 3 -13 2 -16 -3 -3 -5 -22 -9 -42 -8 -20 1 -32 3 -25 5
6 2 11 8 11 13 0 5 -9 4 -19 -3 -19 -12 -19 -12 2 -31 l22 -19 -25 7 c-59 16
-66 17 -41 2 22 -13 22 -14 5 -22 -11 -5 -23 -7 -28 -6 -4 1 -14 -4 -22 -10
-8 -7 -17 -9 -21 -5 -3 3 0 6 7 6 10 0 11 3 3 11 -7 7 -17 8 -25 3 -7 -5 -15
-9 -18 -9 -17 -2 -69 -37 -73 -50 -4 -8 -14 -15 -22 -15 -10 0 -13 5 -9 13 4
7 3 9 -2 4 -5 -5 -9 -14 -9 -20 0 -7 -11 -11 -25 -9 -33 4 -153 -49 -137 -61
8 -6 4 -7 -10 -4 -12 3 -87 -19 -170 -50 -151 -55 -423 -134 -593 -172 -302
-67 -512 -91 -865 -97 -289 -6 -321 -8 -295 -24 43 -26 -157 -23 -330 5 -47 8
-130 21 -184 30 -123 19 -496 112 -636 159 -58 19 -163 57 -235 85 -138 54
-187 67 -95 25 129 -59 378 -146 620 -217 177 -52 479 -103 700 -116 212 -14
630 -14 796 -1 276 22 557 76 824 157 63 19 131 39 150 44 19 6 44 14 55 19
11 5 61 23 110 41 195 69 441 184 656 305 199 112 225 130 204 138 -9 3 -13 2
-10 -4z m-438 -226 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m-41 -35 c-21 -11 -40 -18 -43 -15 -6 6 48 35 67 36 8 0 -3 -9 -24 -21z m-79
-16 c-4 -3 -19 -8 -34 -9 -21 -2 -24 -1 -13 6 17 11 57 14 47 3z m-83 -42 c15
-6 16 -9 5 -13 -8 -3 -20 1 -27 8 -14 15 -7 17 22 5z m-79 -21 c-3 -5 -11 -10
-16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-1058 -286 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M3400 2176 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M3389 2117 c14 -18 51 -42 51 -33 0 3 -15 15 -32 27 -24 17 -29 18
-19 6z"/>
<path d="M8913 2114 c-18 -9 -33 -20 -33 -25 0 -14 8 -11 48 16 41 28 33 33
-15 9z"/>
<path d="M8498 2113 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6606 1988 c-3 -7 -7 -32 -9 -55 -5 -40 -3 -43 18 -43 18 0 25 8 34
43 7 23 15 49 18 57 3 9 -1 7 -9 -4 -13 -17 -15 -17 -21 -2 -8 19 -26 21 -31
4z"/>
<path d="M3588 1942 c9 -10 19 -17 21 -16 6 5 -20 34 -30 34 -5 0 -1 -8 9 -18z"/>
<path d="M7990 1940 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M7278 1713 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7228 1703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7178 1693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5532 1373 c2 -11 -13 -24 -44 -41 -26 -13 -47 -27 -46 -31 2 -20 -4
-31 -17 -31 -8 0 -22 -11 -30 -24 -13 -19 -14 -31 -4 -67 6 -24 12 -54 13 -66
1 -17 7 -23 26 -23 14 0 39 -2 56 -4 52 -5 205 21 289 48 129 43 136 45 215
57 102 16 102 16 95 39 -5 15 -3 18 9 14 9 -3 16 -10 16 -15 0 -13 48 -11 52
3 3 9 15 9 48 0 53 -13 58 -10 32 16 -17 17 -18 21 -5 26 8 3 25 6 39 6 16 0
22 4 18 14 -4 11 7 13 63 9 37 -3 65 -2 61 1 -3 4 -64 10 -135 12 -122 5 -204
10 -266 18 -16 2 -61 7 -100 11 -40 4 -134 15 -210 26 -170 24 -179 24 -175 2z
m656 -69 c-11 -10 -64 -13 -79 -3 -9 6 2 9 35 9 27 0 47 -3 44 -6z"/>
<path d="M5498 1363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6460 1270 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6200 1184 c-119 -9 -358 -54 -550 -104 -149 -40 -327 -62 -497 -63
-90 -1 -163 -5 -163 -10 0 -15 -99 9 -250 60 -41 14 -85 25 -98 25 -12 0 -25
4 -28 9 -6 11 -24 12 -24 2 0 -20 198 -93 340 -126 78 -18 126 -22 265 -22
212 0 281 8 500 60 391 93 425 98 645 98 223 1 270 -6 515 -68 195 -50 463
-99 410 -75 -11 5 -31 9 -45 9 -26 1 -227 51 -385 96 -49 14 -109 30 -133 36
-32 9 -40 14 -30 21 8 6 -4 8 -37 4 -27 -2 -41 -1 -31 3 49 19 -266 54 -404
45z"/>
<path d="M6691 1126 c2 -2 18 -6 34 -10 22 -5 26 -4 15 4 -14 9 -59 15 -49 6z"/>
<path d="M7088 1033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
</g>
</svg>







    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
